import { CustomerInfo } from '@/domain/CustomerInfo'
import { AgencyInfo } from '@/domain/AgencyInfo'
import { Estimate } from '@/domain/Estimate'
import { Confirmation } from '@/domain/Confirmation'
import { Invoice } from '@/domain/Invoice'
import { ImportInfo } from '@/domain/ImportInfo'
import { AgencyInvoice } from '@/domain/AgencyInvoice'
import { TotalInvoice } from '@/domain/TotalInvoice'
import FileData from '@/domain/FileData'
import DateUtils from '@/utils/DateUtils'
import { InvoiceToInfo } from '@/domain/InvoiceToInfo'
import TaxsService from '@/service/TaxsService'

// eslint-disable-next-line
declare const pdfMake: any

/**
 * PDF帳票サービス
 */
export default class PdfService {
    /** インスタンス */
    private static _instance: PdfService

    /* デフォルトフォント */
    private readonly DEFAULT_STYLE = "IPA_mincho"

    private COMPANY_FLG = 0
    /* 会社名 */
    private readonly COMPANY_NAME = "ビューローベリタスエフイーエーシー株式会社"
    private readonly NEW_COMPANY_NAME = "MERIEUX NUTRISCIENCES JAPAN株式会社"
    /* 住所 */
    private readonly COMPANY_ADDRESS = "島根県出雲市斐川町上直江1932番地"
    /* 代表者名 */
    private readonly COMPANY_CEO_NAME = "  　　代表取締役　　足谷　卓実"
    private readonly NEW_COMPANY_CEO_NAME = "  　　代表取締役　　長縄　達矢"
    /* TEL */
    private readonly COMPANY_TEL = "0853-73-7820"
    /* FAX */
    private readonly COMPANY_FAX = "0853-72-2830"
    /* 角印の画像データ */
    private readonly COMPANY_STAMP_IMAGE = "data:image/jpeg;base64,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"

    private readonly NEW_COMPANY_STAMP_IMAGE = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEBkAGQAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAG9AbUDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9U6KKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoopKAFopu6kaQL2P5UDH0VH5w9DS+YPQ0BZj6KiW4VugJ9eRx+tO8z/Zb8qAsx9FM80ejflSecPQ0BZklFR+b/st+lHm/wCy35UrruFmSUVH5w9G/Kjzh/db8qYWZJRUfnD+635UGYD+FjQHKySimeYMZww/CmrcI+cZNAWZLRTBKD2NHmD0NK6CzH0VH5y+/wCVK0oXsx/CqCzH0UzzPlztYCkEwPY/pSCzJKKi88Yzg/pQtwrdm9OlA+VktFM80YBwaTzh6GgVmSUVF56+hpfOHTBzQPlZJRTPN/2W/Kk84AZwR9eKNBWZJRUX2hfQ0vnL70ByskoqPzh6NR5wJxhvyoCzJKKZ5o54J+lJ5o/ut+VAWZJRUfnCjzh/db8qAsySiozOqtgg5pDcIMetA+VktFReeP7rUeeO6sPyoDlZLRUX2hOvOPpSmZR2b8qA5WSUVH5y7Sx4FCzBiBg0Kz2FZklFJuooELRRRQAUUUUAFFFFABSN900bqw/GfiaHwn4Y1LVZlZ0tYWk2qOWOOB+JqZSUIuUtka0qcq1SNOCu27L5mL8QfilpPw/03zrwyzTP8sdtAoZ2J46ZzjPevA9Q/ai8V38k8OnaVZ20inOZMuQvYnkDNcBqvjSXxHq8/iG4Mxv5Hbau8FYjjhEOen4U74e+HLrxJp/iKVLZ2ihtvOjYKcsDkhhx8xzXwuJzSviajhQk4p7W39T94y/hfL8swzq46CnJWu3sm3ayXl+J6B/w0F4u02GIaj9m+0SISqxx8dPr1rU8K/tBeI9RtZ7m7tYxAxxDIyFA4HUj2qOX4e+JdS8J6Tfpp9pfLFbqWikUxyA9DnjJ4/Gq66k+reHU0m18CX1+20W9zcXUIjjiyp5jzkkZ9wacamKi05VZJWur3dzmqUcprQap4eDd7SaaXLr5tE+ufHbxToNuubvT9RndjlrVD5cQ67WOeuKRv2k9cjsUdrWMySDbGWjIVj6DnmvPvDfhPxHrF4+mxWF1DYafg3E1xCybgvJCnbknt/WtjVtI1fxdJarY6NcaelqpkVWhYMVHUniuf61inG6qST7HoyyvKISVKdODtq3dKy6XXn2Opt/2ivFMEi/aNPtpAeBgEM34dqfN8dvF63AhljsbHoczAnr0yOuRXD2/hXxH4gvJ9R063ef7MF+1RSIVbI7BcdR161P4q8L+I5Jo9ftLGSczkH7KkTAx4XBzxz/Sl9Zxjhf2krfoL+zcn9ooezpptfc+i8uup31z8TfH8Omtci50dlIyNoYsB64zVdv2iNYtdKtJrq3RZ+RMiJ8rfTJ6muD0Xwj4o1S3upYLS8hdOfLkRxkd+ax77TfE2m2/2GXQrqQN825YGfcc9yf6UPG4mNmpyt5tsqnk+WVJezlGm2n0stPvO4/4Xt4x1a7e50+SNIc4WGWNePfNXl+PHjgQv5unwwpEV826kQhQCcevNcbpvhzxNHpbaimgXLlH8iW1khbcPRkOOR6g1f1C013VNBSzu9E1SOdflCLAxXy6Sr4mN5SqTv8A15F1MDlfMoxo02k7bq6/HU666+NviiG43xXmn3ELSY2rGScY7YNYzftDeKba6uFkuLOcKP3SJFjr2JzzWR4J8Ka3pd15114T1K4ttuUmjwr5PqDxiuu8NfCm9uNTv76+0GYGE+ZB5hUecMZC47f1raFTG1kuSctX56L7jirUMlwbkqtOEklv7uv4/eUNY/aH8VRadJNafZJVUgNIqbjH6gqDn+tUbH9orxFbwSPLcfaZZpQygwgLGnsM56+tbGo+FfEdja2w8P8AhbyLuST7RN50aGMtIeVY55CgYzjkGqGqeAdf1iUY8FFJrdm8wtIqRy8Z+TA9elVL69/z8nf0nb7/APgBRhkrilKjTSf96N/n/wAB+pt6b+0FrbWzXVzbE27jEbKgwx/OtiP42Xssm5LyCRhjbCFzn13HtXli+B/iHCsjP4dm8uNG2xRkY45AUZ4/rU2h/Cvx1qkc90PD62c8iBVWRxHj1JHeiOKxnwLnfykKtleSWc3KnFeUonoWt/FTxxZ2tzeWUem3aQvvkhBYSpFjIOM81yqftOeK764jSLT7eJTxtVSxJ6Zql4s8D+L9O02G2tdC1Gd1QK5V1k5HPykH+dUPBXg7xVY2811Y6Dcy3g+UR3UQTY31Y8ioniMZKooKU18n/kaYfA5NHDOrOFOT6apffqdNd/tEeKYY1t/Jto7z5gV2EtkdsetJo/xy8X6pqdrbF44WmOzaIQVEmOEznOT0/Gud0j4L+OpLq+1S90iN7ybdc+Ss42lyen1xXS+G/hZ4/wBK8aaTeXdrZ3NuGWd5N+RER1U8dcdOD9acJY+UtXUt8wrUsgowmqapOST6re2y3J/EnxO+JFrHFZzWMulXFzJshmS2EgAHLdQ2eKxPDvxq8dreXoFxFqFjpsbG4e6gCyySFsKq7cAn2rr/AIw3njXU/F1rb6Pot4tnaLiOaNFKTSP8pYn+EKM8/jXK33wZ8YL4f8u00hI7qf5b5I7vaswAyrA4yGPf+da1frKrSjSqVGo+uun+ZyYN5XLCwliqVKDn5rTXVvW60213ZuT/ABt8c6THp815YWcyTZMixg7yOvIHTAqa7/aH1i+tZp7GCNBGBmN1BYZ9q4yX4S+O01K2sLbTJjaeR5rSS3Q2JJ027j82fwrrtB+EviCy0WO1uNHgN0wL+YJhlWPGwnuKdOePk+W80vNP8+UK1DIacYzapt+TW1+quc9qH7R3ieSN1heO3kCgkSIAfwNaGo/tF+IdNtbWVRa3BZfmjcc59c8Vg69+zr40maWa2jtJSo+VHnGSOpxx2qu37O3je8sog9taQXm/jdOGXb+XFc98zUn8f/kx6qo8MSUW5U7ddUbK/tOeJJLNwy2sd0zYXMeUUep56VDL+0l4paDar2/nRsS80cPyOuOM56VQtf2a/HqMpZdOk4DYMxXluCPu9AK2rz9mPxY0ymO7sds21H8uRlEKjrkbfn/Smv7Ta+3+JMlwrTla9P8Ar+v6Zhy/tHeMvssqi6t/OMu5XEIyF7DHQ0kP7QPjSS6ika8iwqndF5KhT7k1tx/sqeIBqCCS6tfsSKRlZCGdj3I21EP2YfFu2eKGaxhh35QO7bvrnFL2eaLdz++RosRwrtH2f3Eq/tBeK9S81LW5s7YIAS80YO4+gyarWvx58YywNOs0c6Btp2xDj3AxSQ/sv+LtPVrhLq2uZi5zA0pA2H0Pr+FXrD9n7xZbxxTIkFvO+Q6iXIHp2qlDM27y9p98jnlLhmKfs3Ta9P6Zo6f8bvEv2VZJlYNH8zjYo3d8dO9ZWsftBeL450Ft5cSmUqVaJTkY7H/Co9U/Z88d3EcjWosYn/um4b5z6njiqq/s5+PZLkCUWUu1QTM1wcsfQDb8tOX9otcqU/uf+RFOHDd/aSlS9CWf9pDxhuDRrB5ajDK0YDbh1GKqn9pLxjdSoIJrOMudoUxBj+Was3X7M/jeaRnR7ASyIAzvMTtbPJxt7im6V+y34ykuFW8n062iSTIkjkZyw78bRg/nUcuZ95/idSlwrGHM3SG6j8cfH1ndKXuLZY15ZY4F2Nnpziq118bvFkkgnbUsGQgtFEAqrj0rrbr9nPxW1nd2n26zuFV1NtI7soVe4I28/Ws5v2ZfFX7tTLpezcNxErZx3/gqpUcy7z+9mFLFcN2Tfs18t/wKEnxy8UvarcpfCODGA2znPv61APj54yunhja+jgjYEFo4wWPvU2o/s6eOrYCKBbK6j3YQrcFQqnrkba2dL/Zt8QNcxCY2cMY5k/eE7ie4wOMe3Wo9nmLdlz/fIqVbhqnHmbpve2iM/SvjZ4u+1QxC6jmJ4fzwoHselWtT+P8A4k0+Da11aSOX+YKuCo7jNbs/7L+tnmHWrNS2Qd/mHb6YOKy/EH7J/iK80ww2mv2EdySWEjpJgMRjPStlRzOK93m+/wD+2OCOK4XqVE5uCX+F/wCRzf8Awv7xS0bRQ6ohkB+VjGhOD+Fb3hH9pbWrXUrWLXLYzwSNtmaKPaVx0IwefpWc37LHivTLNFOoWV+6xYk2O6729eR0ryHWob3R9QubS9jaOS3cq0bEqfr16elcdSrj8K05ykvVtr8bnv4fAZBm8ZUsLGEvRWa/I++PCXjbS/GWnreabN5kR4PTIPocGug39sV8R/CP4kTeFvEmkxGWRbK6uRFNbKgKkt0IGeDX2vFMsyqyg4bpX2OW4365TfMrSW5+McSZHLJMSoR1hLVf5E9FFFeufIhRRRQAUUUlACMeDxXlf7RmoPpvwu1aRG2NKY4g3puZR+H1r1I9DXlf7SCo3wr1ASBiMpjZ97duGMfjiuHG/wC7VPRnuZHFSzLDp/zx/M+ZPCIt9c0fSdIiitbSQuIzOw5dt2d2fX2719m+GfDdl4f0m3tYLeCOOKNYwUHRR0r4g8LWd0fEnha2uFa3t766jkHGGYBhncf8K+lf2ivF2p+DfC+lnSpGgjmn2zSKM/KoBxntnFfMZXWhQo1cTUjpFJfI/V+LMJVxmNw2BoTt7Ryfle/f5M9illitbcyMdkKAkt0AA61Dp95ZalAJrOaOeJjjdGQR9K8h1TxRqOu/s+vqUtx5N3NaJI0yjPBIyPoRUn7NskNv4Ja2i3pLDIxdXPOTzmvfjjnPEUqKjpON7n5xUyaVHB1sRKXvQnyWW3rc9fVojJtAHmf3cf1qNrm1huFgaSFZXHyx5AJ+leYfDu5lk8feJpbucJfebte2QnZtB+RwCe49q5P7Rpt98fdXuNYivYrvTRDJZXMcp8pISASGTPGW9RSlj2qany7y5dWugQyiUqs6bk3yw5tF3t/nue73c1lo9vLcTmK3iUb5ZWAHbOSe9N0vVLDVrBbi0dJLVuA6jAGDzXC/Gjw2vj7wNJbwailiscqXIldsLLt52Zzxu6VW8AafP4d+DO68ka/ddPaWQyHl8qSR9K2+sT+seyUfd5b3OeGBpzwarOb9o5qPKel29xDdf6kq306H8e9WDahuqr+VeIfs3SP9h1QmF7fzLveI/NZ0QMoOFB+71OQK91WtsJiPrVGNZK17/gceaYR5dipYdSvYi+y4GAF/L/61H2VV5CL+VWKRuhrsPK5mVpNkMZdwqqoyzE8DFUU17T2j3LdRNH3YOCPzzTvEegjxFoOoabJK0Au4WhMsZ+ZcgjIrw2x/Zm1TR7qzZfEwGn2iAsEi2ySEHncBhTx3IzXn4itiackqNLmT87a+h7uXYXA4qnN4vEezktlZu/3eZ7be+JNMsYYpbm9hhikkEaM7hRuPAHWr8cizLujYOGwRjB/HrXzF4L8J/wDCdalqOly3lxDH5Pn6bNJHvSAb9pdAT1z9a+gPAvgmPwPoUGnRXU94FO55bhy7Mx6nJ/l2rDCYqrinzOmlHXW+zXQ6s1y3DZauRVm6na3R63v+HqdE42xknH9KwdQ8b6Ho8pgvdQggl/uOwB+nWtXWro2Oj3tyBloYWYD6Amvlf4U+A1+ME2qalqWp3EM0N8+IYWyqd+49KrF4qpSnCjRjec77u2wsoy3D4yhWxWLqOFOnbZXd3sfRTfEfw21mLldUtzbkkLIXAUkdgags/ip4Vvo2kg1e1lRV3blcYwDjI9a8+m/ZU0xtN+xw63fwIX3nDg9+eCKLf9lDRLaMKup3qn5vuyAKAewGOK5/b5pp+5j/AOBf8E9L6rw5yv8A2qd7/wAvQ9Gtfih4XvpxBBrFo8h42rIuf50t98UPC+nzLHca1aJI/AUSqTn069a85t/2VtMsxKtvq11Crtu+UjcPxxUUn7JejSyIX1a+2A5Kq4BJ9c4qXWzNLSjG/r/wQ+p8Oc2uKnb/AA6nsOl6np/iG3ivbC4juoG+7JG2VPr0rSZflJOM96w/Bfgew8C6HbaVpylbWAYG45Y85yTW9MP3L56Yr2qfO4r2lr9bbHx+I9l7ZxoNuF9G97HlvxY+OFp8N1ghS2bULubeAEYBYyFyNwznGcdq81i/aa8SSWBnOhQbsblGZPnHfHTGBTvhvoh8bfGzxJqd/DDNFayvCqP86AhwARnqflP0r6J/4R2x2hRZ2+3HdB+I6dK+eisZj3KpTq+zjdpK1726n31aWUZJGGGrYb2tRpSk+a2+trHzwv7TevLDLcy6Cfs3KRNHHJy5IxnnoKi0z9qvVLEOdZ8PSSR7C4msw21cc4YE19IHRLbyxH9nh2Dou0YH4YpV0a2jU7baEZ6gDg/pW/1HHqzWK/8AJV/mcf8AbGSuLi8vWv8Afa/Q8y0X9pDwpf29gLmaW2u7iQQyR+XxBIR0cnoOeteo2t3FeRLLBIJY35DKRgj1rkPHnwp0bxro91Dd2Vv9oZD5VwqDej44bOOa4H9nnWr/AEn7X4U1YMLywlZY2Lb98ecA57fStYVsRQrxpYm0lLaSVtezX+Rx1sFgMbg54rAJxlD4ot30fVOy22Z7o3HOO2eMVyPiz4qeH/BV9p1nqdxItxfSiKJY1DEZ4BbngZwM+prsJGCqcjIr5H+LS/bfjcsttK1/JZGBpLfbtCLuA2e+etaZjiJ4Whz0ld3RzcPZZRzTEyp121FRb0/BX9T61jkWZQ6jgjg4FP2/QZqrYndbKMEYwMflVsV6K1Vz5qS5XYNhpGXapJwO9SVHcDMLj2q7Ilb2OK/4XB4ZbxkvhhL3zNXztMSqCFPoTmuybgE8DHNfJ2h6TZR/tHXX74LIuoNKiKc4YqMoT698e9fWbD923pivJwOJqYh1FUt7srK3bzPqc9y3D5c6CoNvngpO/d9jk9f+KHh7w1r1jo9/eiG+u22xrxgc45OeM11EcyyAFDuB7jFfGP7Qccmn/E3UWEDbJoo280ndwAcY/u819AfAv4jWvjTwtaQyTrJqdqoiuFXAwRxxzyMd658NmLq4yphZpK23y/q56macNrC5XQzDDtyUkubyvr8l0/4c9T8v1P8AWjYeOacHBwQDilPQ171kfBDccdKyPEvivTfCOj3Op6pcLbWduu55Dz9PzNaksojjLMcADqK+Tfjv8SG8W6xcaXZOzaXYvieF2AW4cHoQOdtedjsZHB0ed7vY+jyLJ55xilSWkVq32X+b6H014b8U2Hi7R4tS08s1tMMoZVweuK+bv2o9LsIvEemvDbRre3ULebP0BUHjPqc1638B7prr4d2HmW8cDLuUxxnKjDHivL/2r7K3bVtIuGiLTi3dVcvhVBIzx615eYVPb5Uqs9W0v6XU+r4doLA8RPD020k5LftffueLeHraW117RXgYNOt3AduchssOTX6A2Gfs8W7lsD8K+BfBFm58Y+HI24aTUIY+BnnIOK+/YFMaKDyR6VzZCtKj9D0vEOX7zDx3dpfmizRRRX15+PBRRRQAUh6GlpKAGN91q81/aAkWP4X6nu65TY2Bw24Y/WvSj3ry79ouXy/hff8AyByzIgGcclwAR71xYz/d6noe3kq5syw6/vx/M+bPA7Xnjb4oaJazzQrHayrKzHAYKhHA+te//tF3mm2fg23tb5HZ7qQxwyY/dxsEJyx7CvH/AAFfeFvAVvoOp38dxJqWpECWNAGeMBgrMe45I+te9/F7wK/xE8CzQWaq10uJ4Em6OfT8Rx+NfMYODlgq8ItSm1te72P1DPcTThnGEqTThRg7J7ap6tfP8DmdT8L6nd/AOPTdN8r7UtnH8qt8rquCQDjuBx9au/BO3sdJ8BlbSb7dqKIz3AB5MuPuk/pXKeGPiNqY8Gv4UutHu9F1mO28tJL6A/Z2AyCwcHAAHvWd4b8dp8PPCdrBp9hPeyzzMlw3LCOZjwyjGSme/at6eIpQq0qyvpFp+VtrLv3PPqYLF1cNXwr1cqnMrWs076t9u2u5b+GUs/jrxQ19cXjWQW4ll8iPrMm7GHyAcDoKz/2gPCtv4Q1g6/aXWqHV7pAQyndAkMeMxt7cd+ma6n4FfDTX9F8Rap4g1sxpDeZMUW4mQEnO7GMAEdq9s1TS7XVLSW0u7eO4t5VKNFIoIYHrxWmHwLxeDcaitJttN/mceOzmGW5vGVCSnTikmltbqr9bHy7qPxUt/ip4NuvC8NtJptwwVQ8pADhBljkdM44xXZSfFDw3b/CU6a2pSXN09j5Crbp87sBgKOeOnfFP+KHwx0vw7p6aj4d0uK21GPcrbAFVkYYbd6jHpzWd8K/g9oHiTSYdQ1KCR7ndh0En7vPcBR0H41z+zx0cR7JtObja7va3T1fkevOpk9TCLFxUoU4zTSVnLm879HZW+Zf/AGXlkm0nULt45FaW6+csSRuC4+X2xivoCsbw/wCG9P8ADVlDZ6dbx21rEMJGgwF9fqa2fSvo8Fh5YXDxoyd2j80znHRzHG1MTBWT2XkOoooruPECqmqyeTpt1JgnbGx4Ge1W6r6gu6xnBIGUPJ6dKT20Lp/Grnz1+zfezaxqmo3F1JI0ltI0ESFcKqbixA9s4r6K55PvXzh+zrfT/wDCYa9aTXkc2T5nkx9I/mx6V9Ic8ivFyh3wqvq7v8z6/iyPLmcklZWVvuXoYHj7f/whet+WpZvsc2AOp+Q147+ynarZ+HbmNrlLm5+0fvtuPlOAR9RXs/jOORvCesLE2yT7LLtY9AdpxXh37Lpmt7fVknblZ1UKqgDoef5VGIdsyw78pHRlvvZBjEntKB9G0VEZ1HYn6UvnL6GvePh+VklFR+evPtR5y+44zTsxWZJTJVLRsBwcUCQHpzSyHEZOM8UAtzyvwb4VtPBHi7XL66e3s59avcWyedxL8pbCqcYOdxIHpXqKybu31r5e/akuLjQfFvhjV9M1a8stXjEjxR5V7ddpHzbCOp3EEjqCRXrvwf8Ailb/ABG0BJ1SSO+hIiuUZQAHGORz3zXjYfEU6WIlgkrNarzvq/n5H2eZZZia2BpZu3zRlo/K2i+Vlv3PSaQ9Kp3msWmn27z3Uy28KDLSSsFAHrzXP3HxU8MW/wBqEmrW6G2bZLukX5WPQdec+1epOpCn8bsfK0sLXrfwoOXornSztmGQD07V82fCKa9v/jd4hnjuImtGDu3lD5ZB5gCn/ZI/XFd548+PWh6PoT/2RcjUb25UpAYfmRTjqcenpTfgT8Mv+EQ0uTVLryzqOpETS7M4UHkKMjpya8TETjjMVSpUnfkfM2vwXqz7PAUp5VlmJq4qPK6qUYprV63b+X5nrki/KSemK+a/iHpDat+0VpMEbvCY7WO5faMB1DtwT35Ar6Wb7jcdq+ZPi42r2fxw0K+KfZ9LQ28KS7xmXcxLgjrwcCtM40wydr2lH8zn4T5vrdSMHZuE9/Q+looxHGAOoqX+KobVt0QYjrU1eytvkfGSTvqPpk3+qf6U+mTZML464qxLc+XVs3X9paCOSGPfHcPMkkYC4V0HJ9SelfULAGNgehFfMdrm4/aWffIFWKXepkOd3yBdgHbBGa+m5TtjYnnivn8r+Kvb+dn3HE7beDT39lH82fJXjyzttS/aAWwupPNsbuaKGVShBDEfKuemD3rqvFnhN/gnr+n+JNAsDLpBfZfQw9Y1JGW+mO3brXP+J7fzv2hoLV3dY57yFiJMYBAGNv1r6d1TS4dT0u5srhFlimjMcit0IIxXFhsMsTPELaSndPqj6DNMznl9PBQvenKmlKPRp6X9f8kQeHPEVp4m0u3vrSQSRToHU5B/CtZn+QnpgV8y/C/xDc/CX4gXHg3XLlksZG32TMDs+ZuAGOOOa+hdc8RWeg6Pd39y5EEEbOxXknHYe57V7WDxXt6XNPSUfi8rHxOa5TLBYqNOj70J6wa6p7fPo/M88+OnxRk8G6GNP06Npdcv1ZbaPHReATn1BIwK848YfCOx0f4Rx6pLarF4h2RySTFjvLsdzqT6cmun+G2m3XxH8UXHjDUok/s0HbpkMke19mSNzckewrs/jpblvhnrLKo8yOIMrHnadwGfyrypQ+uU6uLn8Nmop9v5vn0PqcLiFlGJw2X4d2nzJ1Gnu7/D6Lr5nOfsw6c1n8OY2Z8yTTySEM5IznHB/CuZ/ars5biHRndYzZqZNzN9/dgEAV2P7Nq2y/DmyWDcBvfdu5+bcc/TrXL/ALV0MMGkaPdyb1kjlkQMPu5Kgc+/pU1Ip5Kl/dTOnC1Jf62yfVzl+p4F4GeZfGXhuJG2MuoQyFnbAPIyR744r9AIxuUZ68HNfnr8NZGvPHXh0TJ51p/aEWCOcNuHNfoVDzjA4xxUcP6wqPzX5HZ4ix5cRh1/df5k1FFFfWH48FFFFABSN0NLSGgBjfdNeffHKzfUPhzqECLGXk2qokGR1HNegn7rV5p+0FeTaf8ADO/mgdUeMqTvBOVzgjiuLGWWHqN9j2cnTeYUFHfmX5nz14JtDpfj7ToZr9ba7kSOIyzQ+aD8wP0BzgivseJNsYwARjqDnPvXxj8PNf8ADbeINFuvEjXhvGZUj8jBj8zP8WME/ia+r/GXiOPw74Ru7uGeG2nKbIGuGAXzGOEB+prxMmkoU6k29F5vRea2PvOMqNWri8PS5XzNWvbRu9tH1X5GL8YNQ0+z8B6st2AVngMUaK+xncnAANcF8AbOHTdLia/lQm6O22FwwO4DsM9SPauNb4eeNPiP4bl1bWdfj8u3ZpGtWzgFQRlcDkY5rW+Fui2vjzwqdPgYpBp8olgnkIyrkc4AGRXP9YniMZCsqTWj5U+r8+x1LA0MFlVXDe3UveXO1e0ei3tfXtuj6TWRHyEwVHXZiuE+LmveK9D021bwzYJeGeTyZW6vEW4UgHjGTXEfA/xdqK+Jtf8ACt9dy3qaY4Ec8oxuz/CM8nHrzXucjbYyevGckZz+Fe9Sq/XsO3BuDvbzTW+ux8FiMM8lx0Y1IqolZ67NNXR8ceKfHvim1gutN8UAyaiCQiou1IgR1HHJqz8PPEWtaT4bdorq8jVg5gjghaQmTHAbAOOa9S/aBu7Gbw6k1mlrPeLcKjMu1njB+9+OM1m/AHxVoFjZyabcXENpqLTEmOdthdjxxnGfwr5mWGdPHqlKtuvi6/N9X8z9U+vwq5M8RTwnXWKWmnVKzsvl/mdl8EPEvizxFoss3ie0Fu3nkQyOnltInbcnY16otV4ZEcKyAFT/ABLVjPevr6FKVGmqbk5ebPxjHV44nESrQpqCfRbIfRTPMXoeD707NdJwC1X1BVaxnD42FDuz0xjmrFQXy7rOcAgEoRkjI6Uy4fEj5j/Z70e6034laq9wgj86AsqoD93zMDd6GvqAc5xXzZ8D77/ivr63uLh7q8/eeZIDwMScD3r6TWvBydRWHfL/ADS/M+z4ulOeYqU9+WP5GX4qTzvDeqR43braRdvTOVPFfFHgHXPEtrdvFokrwTyASbI8upGSAfzr7b8RMF0HUWIyBbuSD/umvCf2d0F9eayzaOum+XMqx5AxjGWAP+8awzGi6+KoU1Lleup6fDWNjgssxlSdNTScdHt93/AMK/8AHXxJjW3tk825u3GcxWhUDHZqlg+I3xA0fXoLW7gmujcMo+zrC3yg8Z3Y6+3619Mi1HUomfbik+xqWDGOPd/e71f9l1r3+sS/r/t44/8AWLCuPLLBQtr/AFsfO/ijx54q0XVLm3S21d1uIVijuvI3wROevA5/GovD3iz4i6v4lt4ba2uPsg2o89xCQg9Tg19Gva72BIXr6U5bfbnha0eW1HJSdeVuxhHP8PGk4LCQcrWu9fnaxHarL5UfnEGUAZI/WrDA7TSgewof7p+le4vdPim7u58tftK+Edc8YePtEh0vRri83WjRQXykmEMWyQxH3QQBzivWPg18KE+G3h1rVpTLdXD+fOxYt85AGASOgxW5Z+P7G68a3XhpEJuoIllVwdyuDwc46Ecce9dcF9sAV5NHB0frM8WpXk39x9fjs5xyy+llk48kEk/OXVM828SfBoazNqsttr2oWR1G4Se5RpPNjITHyKrDCqcdq8P8ZfDuHwr8TrCw1KSS70bW5lVpJGA2scLwccHvX12w+U+leY/HLwjd694VF1p0atf6fJ9pjyu4nA5x71jmGApTpSq04+8tf89NtTpyDO8RRxEaFSdoS93orXWjvvo0ibwj8E/DnhO4kuLS2NxLId2+6IfbjoAOgr0SOIIAoACrjC9q4f4R+OYvGnhmG4EomuEJjmZRgbh6exFd5Xo4RUvYxdCKUWr6Hz2azxjxMoY2Tc4u2okn3WAr5v8A2gLiOHx94bdlLPHtfAGflMnPHrxx6V9IP9xvpXzD+0ZJJZfEDw9dtG32VY1YyL22y8j9a8/OZOOClLzX5nvcIRUsySfaX5H0tYsGt1IHGBVkcVR0iVZrGN16ONw/nV7rXsweifofHVFabQ+mTf6tu/FPpkn+rb6VoZrc+V21CzX9pSON0Mkv2raB02sU6+/NfU0n3D9K+VLu6tZP2mLSFrFzLHejMsnC/NHlWX1/+tX1U3KHI7V8/lXx1/8AGz7zim3+xaf8uo/mfLXiqYyftM6ZM5icrdQxLnrGAgOPqSa+pnPyk+3avl3x9brD+054dAVW82SJ2XGOcDDfpX1Hg8D2p5bdVsSn/MTxNb6vl7X/AD6X5s8i+P3w7bxR4b/tS3RhqGl7p4/L6uuOQeOcdQPWvCdG8ReKfiRr2m+G5NQnngnkCzMG+RU43npzjtnBr7Rkt/MUqeQRg1ynh/4V+HfCus3Gq6ZplvZ3lxzNJGD8xznOOgNTjcslia6qwlZOylvqkXk/EkMDg5YfEU+eUb+zdk+Vv/g6mt4a8M23hfSbfT7ONYbeBdqIp6D8a5P49WzXHwv1nau9o0SRUBxuIdTj8a9E3da4D46TJF8K9fMjFN0G1SvUEsuK9PExjHDTilZJP8j5rLqk62ZUZyd5Oa1+aOe/Z1s2sfAqHfuVp3fb/dB7Vyf7V/ia0tNJs9Jktmubq43SBeiKowNx/Hge+K6D9mG6e4+G6K5PmR3EiE9+D1rgf2qJlXxTpEM7IY5LVnUfxAhgNvuDnNeBUm6eSxklvFfmfoeBoqfFk1U15ZSf3HlHwiit2+InhjczhzeqCqjiTGP5V+gC4GAOOK+BfhtaL/wsjwrHDKIy15GV5xjnJH4ivvpVKquTniqyD+HU9f0DxFali6Dv9l/mySiiivqj8jCiiigApKWkoAZ0U15t8fEFx8Ob2IuI97IMt0+8K9Kboa8n/aQj8z4Z3an7xkjAPpzXDjP92qeh7uRrmzGgv7y/M+ePDvgka0tm9m0jx2rieT7N8shkU5yM+uK9q/aAkgj+G9i1y0sUnnxyLE6htzBScEHqc15BptvqXh+bSdM0G28pZriG4W6vGJf5QM8cfL7c17x8aI5JfCulStaRXl4t3EYUZCyiQggMR7E18thYx+rV7Kz5Vf8A4B+rZvWn/aeDlKV48za2v897XKXwW0m6n+DIhuXme5vYJWPmMAy78gLntxXG/s36Lc6D4s8SWc0gmKhVZ4sshIYhdpxg8HmvR/AK61p/wqmN/arBqyxSNJEv3Q3t7YrzP9mnVrvUPEXiMyD9zCFWOEcbOu4exzXWoxhUwMWnzK/5dTx1OrVw2azTXK5Lb/FpbyNv4e2mn6l8VtTksLmZbi1uZjcLcAOZMsANpB+UD0xXX/GbXvEENqNN0O18yOSF5LmQPtYIByFx3Ncr8O/ElvZfFLUtMS3Mb3DPIZDEBI0gPzKT6DqPWqn7R3io6LqunW0BuI5pY8SNAcHYGH60vaRp4GrUTs7tO2mvzMpYWpic6oU+W/uJrm12W/TrexyY+COut4YOt2mqQzWGft0lhKrK7EKSwJ7njvUHhbwG/jXwPe65pkdrYm3aURhm3uMDLEEDg+nNe7+LPGFt4S+F76ncApEYERdwAIZwAMjueeneuK+C10t18MdccbSWa4JfaAT8voOBWMsDh6denQjtKLbX6rqvkd9POswq4Kpipq3LUUU7dOqdtH01epH+zT8QNU1yG60XUZGneyVCk7fxKeOv1r3/AJ2nAGfevmX9le7L6pq0Cxoka7XYbssGJPHTgD+dfTTdD64r2MnnKeDi5O+6+5nxvF1GnQzapGnHlTs7eqR434q8Xa7a/HDQdLtmeTSZIAZ4VXgFmIDk/wDATXsm414z8eLDVNEn0jxdosTS3GmS4uIlP+thIxg8dBkmvTvD/iKDXNKtb2LcVmUPjHtzWuGk44qtSk23pJdreRw5hRjVweGxFGKSs4u2/Mn1+RuVXv3WOyndjtVUJJPbipPOU8c5rmfiD4mtfD/hDVbmZ1Rvs7iISEYdyp2j8TXpVJqnBzlokeHh6M61WNOK1bSPEv2ddBDeKtW1JbjfHubdCAQEkZyTz3r6UUdfrXjH7Nnh2fT/AAiurXPE+qObhlYnIz0GO2K9nzxnFeXlNP2eEi7ay1+8+j4oxCr5nUs7qNl92n5lDXkeTRb9Y8eY0Dhd3TJU4zXiP7L7SPYanJJu8w3GG3Pu6DGfYmvc9UjebT7pIgDI0bBQxwCcV82fA/xpaeDfEep6HqRaHdKxjmK7QSudyn0+p61li5Rp4zD1Juy95fhodWT0qmIyrG0qSvL3XbrZXufUFFcXZ/GHwlfsRBrED4J/iAzgZJrOHx/8ENPFGmrCTzH8tZFQ7c/U16X1zDLerH71/mfPRynMJNpUJaf3Wei0VxeqfGDwrpEcrz6nGRGcN5ZDY4z2NZk3x+8IW8kSPdTfvOjCLI+p5oni8PT+Kol8xwynH1FeFCT+TPR6jnG6FxnHHasvQPFul+KLUXGmXS3cOcbkI/KtWT/Vtn0rpjKNRKUXdPsedOnOjPkqKzXRnzl8PrV7P9oLxJPbTqtpdEh4ZJNz+YDknb/COnQ9q+jRnv8ASvm7wlaRr+0XrBH2d3idn3qxEh3DkEY5x0r6Q388142WPSr/AImfWcTW9vQa604fkOwcVFcQ+ZA6HoVIqemyfcb6V7Z8fHR3PnzwxqVv8LfjDqWkXLSJYavKJYFVMJG7H5VHQYxkflXv6ybscHnpXkn7QHhR7zw7DrFjGrahp0qyKzZ+7znkema6r4V+Km8WeD9Nv3ZWmdAJdvQMOD1rw8I3h8TUwj2fvR9HuvkfYZpFY/B0syhv8E/VLR/NHaEE145+0R4Pk1vwrDqcAYz6Y3mrGvRw2AQfYYB/CvZcHtVe9s0vLWWGRFeN1KFWGQQa9LE0FiaMqMtpHz+XYyeX4qGIhvF/8P8Agc38PdYXWfDOmzo4ctCu4r03AYYfmK6ocV83Q+Irj4D+NrmyvYrlvC1yd9vtG/YBjhB046YJya9Y0P40eE/ESsbTUl3Iu50lGxkHvmuLC42m4qjVklOOjT8uq8j2szyfERn9aw0HOlLVNK+/R22a2O63expk0gEL9uO44rlrr4oeF7XTxey6xbLbdPM8wf45rzPx5+0DBq2jpZ+CnN9q17J9niiIAcZ43AZ6V1VsbQw8eacl6Jq7OHB5LjsXNKNJpX1bTSXqzO8D6WfFXxs1zUJ3z/ZV08e1hv8AmOMANxgAHgYr6EkzsbHpXnvwZ+H8vgzwxGt9+81a5Pn3k24kySt1Y5FeiMDsPfjFYZfSdOlzz0lNuT+e34bm+fYuOJxajTd4U0or0XX5vU+WfHytB+0NpV6sqM7XVvbrBIxZug+YDHAz719TI24KT3Ar5l8b2U8f7SejFII0SdoHywOZcZ5HuuOa+m1GMVzZfpXxF/5j1eI5xlhsCl/z7/UkpG+6aWkr3T4YY3AY15z8eryG0+GOqea6KsgWMeZ0J3DivR2X5TXAfHDSLnWPhnrUNqEM0cPm/MuflU7mx74Brjxivh6i8metlLhHH0HPRc8fzOO/ZhsZrXwDK0sqP513KyqrcAZGOa5v9q9I4DoN09v5pV5ELeXkqMcDPua6r9mKOZfhxb74WiVp3dATlSv94HuDXOftbTXQ0bR40DCBZmc7f42A4X6c18/NL+w0n/KvzP0TCycuLnrvOX5M8a+Etuo+JfhchnwbpJAEYY6D9Oa+889q+LPCVlZ/8LE8C3WnadPbLdTJLOcjarcgjrnHGa+0wPStcijy05rz/Q5uPqqrYrDzX8r/APSmOooor6c/LgooooAKSlpKAGt0Jryz9oa1S9+Gt6jzrbKHRxI/IGDnp3r1Nq8l/aVYQ/DC6mKeZtliIU+u4Yz7Zrgxzthaj/us97If+RlQt/MvzPla38VavrOraVE8rpMxjjWSIk4wRwOOcivo/wDaFvLi18B6V/xMJ9Lb7ZFuuIQCRgHH614npmqf8ITqGlXttYSXX9pW6qlsybmSQMPnAx8w98DHvXvnx31Wzh+E6ve2y3EkzxLDFI2395kHP1ABOK+QwKX1fEKUtbL/AIH3n69nlRPMsA6dK0OZpWtq7pPTyKfghtT034J6rJJdS3V/5dxIJJmOWyTt57cEfSuM/ZVSaPU9cXz1nt9q4badzMTkknHPpXfeHdTj1b4D308cnm7rCUSFfUKQwrif2V4d9tfTm4twVUQi3jG2UAHO48nIOeor0KeuJwSi+h4bb/s7NHNWbqJbeZLYyXcP7RkqJDPZJICWaZDtuE28BDjGAec9aoftHC21D4jaLpzRrcXLWy4hbKgqXwBnp1FS3Gpajp/7Q0GmvK1zaTT+bFGWLGDchJIJ6cj7oyMflXQftNzNp2l2F6ltCZo2zDcMMlH5wOOcZxj3rCul9TxN3op3/wAzooSnTzTAytrKlZW+aXn/AFodd8RfB3/CXfCl7OZY4pUhWcR88FRnAP51Q+HfhvTfCvwpu5bNzLHPbSXEjBt4LFTnH5UnxC8QBfguuqSyzRMbaGb9yPmJZRxj055rF+EeqWkvwJvzBDLFFBFcJ5OSxQgHpn659q9HngsXTaXvezbufP06eJ/syScnyKslbpf+rWMD9mPUhqHiTVSyxrJsGdqBWOWzyK+m254r5N/ZXVLTxnqUchY3E8AlG7+6Hx1719ZVrkkubBr1f5nHxrBU83ko7WX5Iqahp6ajYzWsyBopk2NXgl54R+I3w31C4n8PPb63pbDC2pYgpznO0+nsfwr6H20yRTtJ46d69HE4WOI5ZNuMls1ufOZfmlXAc0FFThLeMldf8BnzGfjt45S+fTn0QSalJL5ccXlMmB3bPpXR2Xw78afEmaOTxhfwW+lbkc2MIO5sEEDp8te3tbwLIn7tA54BwKspncvAX6Vxwy6fNevWlNdtl+G57lbiCnTingcNGlL+bd/K+xW0vSYtJs4raBESKJQqKO2Bj+VXdpp1JXspJKy2PjJSc25Seo1lypHtXmvjH4G6N4t1Jr5i9pcONkvknAk44yPUHnNeg3+pQafYz3Vw3lwQoXdvQAc1w3gP42+H/H15Na2P2iO4jcqFljADAHqOTXFiHhp8tGvbXZM9jL/7RoRni8EpJR+Jrpfuc9H+zH4f+ww20sspWNQpKNt3fXiov+GWfDisHS5vFlBH7zz+cDt93AH4V7SHB9c0uay/s3B2t7NHX/rJm2tsRI8ht/2afDkNrLbM08kMihSDJz7nOO/Q01v2YfCSlmCXSA88TtXsNRXU62tvLM5wqKWJ9hT/ALNwaVvZR+4lcQ5s3piJa+ZzXgf4eaT8P9P+xaTC0MJbcQxyWPrmunZNykVwXgD4taf4+vNQtrSCaKWzl2NvAw3PUHNd9urpw8qMqa9hbl8jzswhi4YiX12/tHq776nI2Pw10nT/ABld+J44T/aVyipI27jA9BjvXTSXEcXL4XnvxVhlLKQDg14x8QvgnrnizWLy9i8TTJBKv7m0Z2SOAgdRtznmsat8LByoUuZt3aVl8zowyp5hWjHG1+RJWTab0XQ9gXUIWxhs0NfQ4I3D86+YfE3w58V/DnQZtQn143qRkYYTOpRj0YDH6Va8OeAfEXxN0NbpfElzFFPjebiZyCR02hSOPxrz/wC06rqex+rvnte10fRS4dwipfWVjF7K9uaz39D6G1BbfVLOeykKtHMhiYZ55FYXw4+HsPw70Uabb3Ml1GJnlDzH5gGOcfhXA+GfgFruk+ILC+u/FE00FrIJPLjnkzJg5wc8Y46V7csexQOuK7sPzVpKrWpcso3S1T39Dw8d7PBw+rYTEe0hLV2VtVtuO8wc01pBtPb60MvymuB+MC69a+GjqXh+6aC709/PaMLuEqD7wI78ZrrrVFSpupa9jyMLR+sVY0uZJt21Ol8ReFrDxZp72Go2sc9vIOQy/wAj2NeUX37LunQxyDRtRmsS4YMkrb1YHt0zius+E/xMj8caSnnkrfx4EyY4ORkMB6H+hr0VX5rh9jhcxpqtKKlfr1Xke6sbmmQ1ZYaM3Gz1W69bPQ+d7H9lWea4xq2p209qYyjfZ1ZZT6ckYx+FemeCfg3oXgNVks4FmulOTdXADSY9AccCu/qOaURxs5+6BkmqoZfhcPLmpwV++/5k4ziLM8dD2VWq+V9FovwGeYFIXB67RT9w5A/GvBf+E01D4jfFy1ttBupYNL0xyt024qkuG59c/MMV7z82PXitcPio4ly5Fona/f0OLMMunl/s41X70le3Vdr/AJlC50S0utQt72a1ikubfJimZMsmeoB/Or5kC9jWF428UR+D/DN7qsyl0t03bV6sew/Ovnnw78T/AIm+Nb97jTrRP7O3sqSLANoHYcnk+9Y4nHUsLNU3FuT6JXZ35fk2KzSjKupqMIaXk7L0R9R/aB3Vh9RQZ1A6H8q+bZH+M1u00ikSqvCoYk5Ge3HWs2S9+NSSOVt53lJDLlYwmB2rlebJf8uKn/gP/BPUjwvz7Yul/wCBf8A+o/tC85zUMzRTRNG4VlZdrBh1B6givmKa7+NDXilYbrc8R3ErH5SnHUAc7qdotr8YZNa07M12sbXAMpuwvlRpkZzjlvyqVmybt7Cf3F/6rqEXN4ulpr8X/APpax0+DTbdIbaGOGJB8kcahVUeleGftRwyNY6FOl0iGOVwtuXAMhIHODxxXvMCy+SnmkbwPmK9zivnr9rbbNpegJ5XmAXDl2HUKVAwP61rmtvqFSy6fqjk4W5p5zRu7u7/ACZ5N8Mr64/4Wp4dR4EMk12v7xuNqjJIXjH8q+5wa+IvhzZvB8UvC8gkVolnUA5ztyOgFfbq1x5Hf2c79/0Pf4+cZYqg4/yfqx1FFFfTH5cFFFFABSUtJQA09DXlX7SEvk/DC+bzDE6yR7G4wG3DB5969VY7VavI/wBphZG+GN0UOAJYyy4zuG4cVwY7/dqlv5We/kMVLM8On/MvzPGPD/iKDXvDOlapryCH7PCUS6AEZRN2Ox6+n8q+itc8B6Z4+8G2emXTPJa7I3jlz8xwAM59wTn618Vae1zqQhs43EBjmScRPyrHcPmb1+lfe+l3EdnoNvM5CRRwhnYDAAAGfpXzuUSVdzjVV1ZXv+p+h8Y0pZdUoVMPK0uaTSXTZq33mZo/w9s9D8IP4ftmMds0DQblOCNwIJ6da89+CvwP1D4b6hqD3l1by28h2QiAEEjIIJyOPoDiu88LfFzwz40806Rem5jjIDSFdi89ME4zzxUniX4oeHfCsbHUb1Y5RGZFhUgyMB6DNe1Kngp8ldSVobO+h8RDEZxT9tguWV6tnJNat737nMab8DYrH4mXPi6TUZblncvDayH5YsgA4/X86tfEn4L2XxI1Gxvbi+urSW1wNsch2SKDnDL0/GqrftIeD1tUnae5QSRGWNWjGXGcYHzdzVm1+O3hu8RJkkf7MYnmkkYABQvbOcVipZbKE6V1abu13Z1yhxDCrDEuElKC5U7bJdDY8YfD2HxL4FufDyu0AaARxsrYwVxtz7cc1z3wh+Et54H8H3WlateR3k908jyNETtG4YwMgdqqXH7THhiG3kke21EFP4Wtx8393HzdPerH/DSPhNbdmBupZFXcYYo1Zh6gANyQO1P22X+0VTnV0rb9Co4XP6eFlhVRlySkpPTqvMk+HPwMs/h7r95qMN2915vyxLIeYk6lRx616kOvNc14L+IWj+PLH7XpUzSKDh0kADofQjPFdLu9a9DCwoQp/wCzJcr10PnMzr43EYlvH39otHffQdnjNRTy7YXPIwOtOZxHzjI9q89+M3jKXwr4OmW0wNTvyLS1XnJdh2x3xW1asqNN1XsjmwmGni68KMN5Ox494m+MOrL8QF1O0uWk0iCXyFton3JLnv0wSfrX0h4f1uPXNNt7tFK+aisc9j3FedaD8I4P+FYJolwlul5JbY8+FduyQgkMpxkEE9ap/BjXJrHVdR8L30ha508Jnv8ANj5ue4yR2rwMJKth6ylWbtV19H2Pt80p4LH4WX1KNnQ0f96O3N957RSN900bqQtwa+lPzw5zx9HnwZrRz0tJMc4/hP618m+EVvbW8XxjoekBoNIQNcwkEPKM5JXgDOAa+t/HEaSeEdYR/um1kz/3ya85+A97Y674D8mNWfl4pVkUZ6Yx9K+cxuH+s4unDmto7eqP0PIsc8Bldeoocy5kn2s07/etux3vgzxtZ+MNJt7y3dGaRRvjVgxjJHQ4NdOvHavnePQZfgH40jvYrlpPDmqS7ZoiOIP9onFe/wBlfQ30Mc0DiSKQBlYdCDXo4OvOonSrK1SO/wCj9GfOZtgaWGnGthHzUZ6xf5p+aLdZ+vwpc6HfxSHEckDqxzjgg5rQqjriCTR75GG4NC4I9eDXoS+FniUdKkX5o8A/Zms5ItQ1qWQuSzqse5cfIMjr35r6LA5rwD9mvUTP/asMgkSaOfmOTHyLk7cc+1fQGa8nKUlg428/zPquK3KWa1HJdvyQtI3Q0tI3Ck17B8gedfHJvL+H16xZUVSpLNg/z6VH8DdPOm+B7GJZPOUDIbPPPOOlTfHC6Sz8AXk80LTRxOjFQN38Q5x6U34K6p/a3g+0ud7SF2OdygbccYAFeLZf2ku/J+p9iuf+wXb4fafjY9Gooor2j44Ttiobi3E0LI48xWBBU9x6VPSNyp/rQNNp3R81eILNPgr8RH1dopm06+bEJhy33m3PHjgZzkjmvoHRdZttbsYLq1bzIpVDKTgZB71R8YeF4PE+h3NpcRozshMcjD7jY4b8/SvC/gf4w1Dwf4kuvCniFmjcykW7MMAMT936HqK+eT/s7EqD/hVHp5S/4J93OH9v4B4hfx6K1/vR7/LqfSjNgdK80+MXjtNB8NvpdmJpdd1WNrWyghxv3Ect14x6+tdX4r8XWfhbQL3UrtsQ28ZbA6seyj3JryL4TaVf/EjxMnjXWCjxQbl09QT8gb7w6fSuzG1pXWFp/HL8F1f+R5WU4KMYSzHEq1On/wCTS6RX6+R2PwY+GDeAfD8IuWEuoTBXnfcSQdv3ckcgHNemdc4pPLPH1z1p3Kr0rtoUIYelGjTVlE8XG4ytj68sRXd5SPNvj+6L8LtWLqzJlBtUEljvHy8etUv2fXE3w60xwm3zNxwwwR854/LFdB8Yrk2fw312YOsZjgJywz6f41i/ALzG+Heks9rJaOyktFMfm+8ea82yWZxf91/mfTUpf8Y/Jf8AT1f+knp3lnuRSeWf9nP0qWivaPjrsi8s89KPLPU7fWpM+1GetArkbdGJr54/astoo7HRbtlmM6ytGnlNgDIHJGenFfRB+6x/Gvnv9qb7VHpummOBXhYlXldu/YAV5Gba4Kp8j7DhP/kb0fX9DyH4R609/wDErwzFbWxMYnG5toyeOSTntX3IP618M/BiG6svih4eMwFutxLkrjGcDgV9zA9K8/Iv4U/X9D6HxAUVjqKhtyf+3MdRRRX05+WhRRRQAUUUlADW6GvLP2ilk/4Vrd+W6xM0kY3MM9x+tepsOteU/tGzxQ/De4EzGNDNGDt5yM9P0rgxumGqf4We9kV/7SoW/mX5nx5Z6jJYXkTsVkl3IqDGPmzwc/WvvzTbVdU8Lpa3aCSOeDy5UJIBUrgjivguGxj1DVrIWysyF48r6AMMn8q+/dHkjh0WFyf3axgktxwB3r5nIP4tW+1kfp/iBJKOGcF713+h4rrP7ON5ps2oXvhvWxZz3Db0hmUhYuxClRnGM8GuN8F+CpfiPqmr6G9/NENKkMFzqC/NJJP3XcRwo9K9b8UfGjSLzw7rp0G/hlu9PdoZvNbaMgfwHnd6DHeuI+BfxK0XS/D8sl+GhvpriSe4fYAzszd+eTW9WngFiIU4u0XdvV8r8t7bnn4XF51LL6terG804qOnvLzemqttfvc7S3/Z00GbQ7Sx1Em9ntxhLv7sgHpwOmeaWP8AZu8Kx+HH0doppbY8hmmO9T1yDjg5qWb9pjwNDOsZvLg5OGcQfKvPfn+VTj9orwWTOGvZoxCGLM8YAODg455wSK9BPKlonD70fPSlxPbWNRJu+z38jNX9mvwyFlQrcCCRVVo1uGGcdyev5YqKb9l7whcMGeO7AUYCrduoHqRjnmtDxN+0T4U8OtbfvJ78ToXVrRVcAA45JYYNNuP2iPDFrotvqTm5YTMFEKKGdM/3hu4rOUcpTakoXWrNI1eKXGM4upaWi3/rodj4P8A6T4F09LPSbZYIRye7MfUk8mujrl/BHxH0f4gaf9s0mSR4g2xvMUKQfTrXUs3yntXt0fZumvY25eltj4zGrEqvL63f2nW+9/MYx+U54rxe+1J/HHxytdOgfdpugQ/aJlZAUadztAz6gZr1DxVr0Ph/w7qWoz58q3hdyF65A6fnXBfAnQWTQH1y4dpbrVpTds0i4YAnhT9B/OuHFXrVIYeL68z9F/mz2MtisNha2Nlv8MfWW/3K/wB56oVKrjAwOleDfETSz4E+Kmj+LIN6W166wXrBsIAAfmP4fqK98ZSc4xXC/GTwSPGfw/1OyH+vjjM8W3kl0+ZV/EjH41pj6Lq4eXL8UdV6rUxyXFRw+KUanwT92XpLT8Nzs7O+S9t4pozuWQAg/WrGTXnXwX8Sf8JH4NsGkbN1bg28y9AHQ4IxXoY9K6cPV9tSjVta6uedjsNLB4ieHlvFtGJ40k2+EdakCeZi0kO1u/ymvI/2YZov+Eduo4oGhK3Bzv5LHr19Oa9U+Inm/wDCDa6ITskNpKA2M4+U815T+zDA8eg3Tby4Nx8rM2T0Gcjt0ryqz/4UqC6WZ9VgEv7BxTf88T1Xx34Ng8aeHbjTpjsZgGSTPRhyD+deVfCXxrL4X8RTeBdcvfPvLPAhmIwHBPABOM8V7yykqenSvIPjZ8PzqFmPEthaCbW9NG9ShwSo5z7kY4rXHUZQksXR+KO/nHsceTYqnWhLLcW/cns/5ZdH6dGeweaMAgEiob5l+xz7923Yc464xXnXwe+Kln480KKNnb+1LdVjuomXBVsckZ5Izx9RXo1wd0EnHavRoVoYimqsHozw8Xg62X4h0K6tKLPFfgRrukajqWrR6XFcfZ1kXZNMoDuMtndzkEGvbxXg/wABVt7fxJ4hs44nSWOYMzsMFuW6nvXvFcGVtvDJvvL8z2eJIqGYSSvtHf0Q+mt9006kb7pr1j5Y4H42ssfwy1t2fy1EQyT3G4ce3Ws34C3Ed14Hs5I4/LBZsr+J5rS+NjwN8NNZiuFzFLGIiSMgZYc/Ss34CtnwJZjKsFZlBVSoxmvDf/I0X+D9T7Cn/wAiCd1/y8/9tPUaKKK9w+PCkbpS0jdKAIZB1/KvE/2hfAkMmkDxPZt9l1WyK/vVBy67hgfgea9ubo1eW/HXxRp1n4TbTZN8t/dsot7eNcs5DA9M9M4H4152YRpzwk1U2/r8T6Ph+rXpZhSdC976+nW/lbc8Ks5fEnxovNK0qfUJEgWcB5Vb5Y8YJBHc4HevrHw34btfDOmW1jaRpFFCAo2D8z+NfM3hfT9T+FusReIdT06WytJZYlk8pfMZozjCgdBgnk/rX1FpOtWus2cN1aSrPDMAyOhBBHrxXkZPGN5SqX9o++9vn0PqOLqs37OnhbewV7cu3N1vbS5pUh6GlpG+6a+oPzQ4f4zZb4YeIwBlhaMRkZGR0479K81+DXxi0nSfBOnQaqbmBof3TTy4YHqck54+lelfGK9Wx+GuvSMu5Gtiu3rkHA/rXlfwd+DWna14RsNQ1WPzJrmNZPJLHZGPTHQ5FfO4r27zCP1a1+V3vta5+h5XHA/2HU+vX5faK1t78p3tr+0d4Ku7h4UvJw6kghocdO/XpUmtftCeD9FxG9zPPcsMrBDFl/bgkdazpP2ZfB8jO/2eYSO24uJiCfY+1If2ZPCLK4aCZnY5MhmYv9M+ntVv+1rWShf5mPLwvzJ81W3bQgsv2pPCdwsEk1tqlpDK2wTTQKFB9DhzW74f+PPhXxP4gi0eymuJLiclYXMPySEdcHPasUfsz+Hn2xSy3DWauHW3WUhVOMHtW74J+B3hzwFrDajpluwmKBF82QuI1znCg9P606SzRTSm48vV9fkTi/8AVn2U3Q9pz2dlpa/S9/xPQf4TXz7+1JcJ/Z2kRshBR3lSRTyDjaRjvwa+gv4Tj8K+fv2p7Vhp+jXCyBSsrp5bJuBBAP8ASunNG1g6nL5HFwrb+1qPN3/RnjHw5a5uvif4YzMkRS9RR5rZAxyVX3Ir7oUHjNfEHwijkX4ieHpnk820+1qIo1wQrngt6ivuEf1rzMhu6dRvufS8fv8A2uhFdI/qx1FFFfUH5YFFFFABSUtFADT9015H+0lavdfDe4WLbvSSOQK3fBJxXrbdDXlf7RDSr8ObloQC6yxjb6gkZH5Vw4z/AHapf+Vnv5DJrM6D/vI+SNJtbibULKERTLCZ1JWPg7e/Nfe+m2qtosMON0ZjC7Sc8YHWvjTUvEml3WqaBb6VC8NyjIoZhtV2yMg+tfaOkB10+DfgEoPu8eleBkcVGdSzvsff8dVqlSGGnKPL8WnXdHjnxA/Z/wDD8Oh6rqGmK+kXCwM7NA2EYKCxUr0AJ9K4H4EeBtI8W6g6amiX0unFZBNC7bGdskqRwCRjtX1DrmlrrGj3ljJwlxC0RI6/MCK+btD+IVv8Cbe70PUrC5vNQt58Ri3jCLLESSJNxx2OK0xuGw1DE0604qMNb9vu/wCAcOT5pmGOy6thKdSU611y66pbPX8LX6nrOpfAfwdqk6vNpEJIXGFLAH6gGom/Z98FtZC1OkR+V5nmY3NnP1J6VyLftWaPHplvdvpd3++PEYkTcMde9Wl/aw8KeW2+01FLgHCwmFSzcdvmxXR9ZyqWrUf/AAH/AIBx/UeKopKPtLLtJ9Pmb/8Awzn4IRoyujxIqNuCq7AE5zyM81rap8GfCutpCt3pFu4iYFQgKdBjtjP41zNn+014VvkDRi6jfareXKEDfN0GAx5q/wCHP2ivCuvXq2jSXFlcM5UfaIwqnHfdmrhWyuS5Y8mvkjkrUeJY/vKntPd83p+J32h+GbDw3apbadaxWsC9I4lwK03B2mobbUILyMPC4kQ9GUgg0+4ukt4JJX+VEXcSfSvbioxSUdEj42pKpUm3Uu5PvuePfHvxMLa30TSYbsW8l3dIJixHMfT5vQZPX2r0rSZLey023ijKhEVQPTbxzXg9v4Tb46eJtb1lJY4rEFrG2uVY5bYThgMYGGqxJ+zX4nktxG/ixJC5zPu8wCU4xk+hx2HFfO08RXdaeIpUeeL0WttvXufoNbA5csNRwWIxKpzhrJNN6y16dtj6COqWwTcZPl9cVDcavZLZySvKohCklmOBj6mvB4v2W9RWDZJ4iSfjAVw+0Z7cGtGy/Z51uG0Ec3igfd2GNUZokUdNqk9fc12RxeNv72F/8nieTLLMnjrHHX1/kZR+F/iSHQfilrehwYNjd3DzRBSMKxIyevQ9a+gs/N09q+fvG3w5vvhzoFtr2mzreXdi4luXfhnXOTjjoAPyr2Twf4ij8TaHZ36BgJ41fBx3FRl8p0ZSw1bSWsl6N7fIrP4UsUoY/Cu8WuVv+8uvzWpb8UbV8Pak0qLLCLeQvGTjcNpyM9q8h/ZzULY3ux7cKJQBHASQgySAfU+9eueLmi/4RfV/P4g+yS7/APd2nNePfs4xWZg1CS1bajSqBDtwEwDznvmrxF/r9D5/kRly/wCEbFvXePoe8beMVHLCJY2UgEEYqWkPSvZPjtnc+evEHw51P4beKm8W6XIJ9MiZpJ7ZMl9rHLDGOQMevc17H4f8UWXibQYtQs33xzJkAYyD3BFa95ai5s5oXVWWRdrBuh+tfP8AcahP8CdV/smy0yS7s78PcIySfIr5yRz0x1OO1eHKKy6r7WP8KT1XZvqj7anUlxDSVOprXh8L0XNFb3813J/gS19bePPEkF3cNNEZQ0O4YbG5uv519Bqa8A+BNy3iDxVrOtTzwSTybU2Rt8wAPcenSvfu/tV5S08Mmtry/M5+KNMwaas1GKfrZD6RvumlpG+6a9k+RPO/jlM1r8MdZmSLztiA7N2BgsBz+dU/gLIJfAdk+EXcWI2HI6//AFq1PjPH9q+GPiBApIFuSwGOQGBP4YFc/wDs5oI/h3Ycry7Hapzj5uleI9c0i/7rPtKVnw9N9VVX/pJ67RSBs0te2fFhSHpRTZG2xsSOMUAZniDXrXw/pN1f3kghgt0LszY/L614P8I9HuviR4yu/GGqWq/Z1k/0Ms7EAjgYB6AAD61p/FDVrj4k+JrTwZpqOLNZVkvboDgAY6euK9h8OeH4fDul29lAiKkKhAVG3PvivDlF47FJX/d0/wAZf5L8z7SElkuXvpXrL/wGH+cvyIfFPhuPxLoV9psxEcdxE0ZkX7y5HUeleI/BvUL74Z69/wAIv4i1FYYyfLtLdwFUkNwU54Ujt619FMp9q8t+Nnw9TxNoA1K1tvN1fTcTW7KfmGDkgGtsbRlpiqS9+H4rsc+T46EoTy7FP91Vtrp7sujX6+R6kswYA4PTNO3DmuA+EPjCfxZ4Tt5rsbLuItDIPVl4yK7zf8pOMYHeu+jWVenGpHZq58/i8LUwdeVCpvF2OK+MOf8AhW+uhXgjfyOtyCYzyODj16fjUPwa8r/hBNIWON4x5QOxlwR+GTj861PiNb2s3gvWIrviB7dgd2Dg9j+dcz8C1e08C6bDLIJJEUqWyWZgG4LH1xXC7rMF5w/U92mubJZpdKi/9JPUqKi89du7DYpBcoeOfyr1T5jlZNSVH56+hNH2hfQ/pQHKxx+6a8m/aHks7fwOJLgx5WQBUkPDZHPP0r1csGB9K8B/ats5pfDOmzFwtpHMzOFGSflwOPqf0rzcxly4Sq7dD6Xhumqua0IN2948T+ECtbfE/wAPOY5E33ewKON2RnkZ7D0r7tFfDHwRvreXx/4ZS9geVxcbYZl58uTaeCfcdfavuivJyFWozfd/ofW+ITf16ipL7P8A7cxaKKK+oPysKKKKACiikoAa3Q/SvKf2jFH/AArG+dwrRoUZg5IGAa9Wbo1eV/tGxmf4a3cQIBeWJRkZB+YcY964cbrhqiX8p72RO2Z4f/EvzPlLw74sNj4y0i/ls4nSK5VJIlTdxxtIH9a+9dNuftlnDMAQHUEBuCBxX5/aVBJplzC7QgLvX588jJ56199aA2NGtD1/dqf0FfO5FOTnUi32Z+jeINOn/s84Luvyf6mqRkEVz+veCdL8TRlNRs4LlWXady849M+lHiHx9oPhWJ5NV1GGzCfeV3Bb/vkc/pWRbfGrwdeRu8Gswy7fvKp5H4V9NUq4fWFSUfRtfqfmGGwuPSVfD05eqT/NEp+EvhhlQNotkdnCfuh8v0qC1+DfhWzvnvItEs1uX6ybMn8OOPwqCz+PPgu/lkih1ZWmjzmPGG46is61/aQ8GXStie8iIBYCW3KllHVhzyPpXH7TLU07w/8AJT2I0M/aaUann8XU1z8FfCDXX2k6DYmb+95Wc+mfWsnx38I9EvPCV9DZ2Vpp9wieZDJGgVUcdCcY4z1rU0H44eDvEt19ms9VUz8YSQbCc9MZ61v+L7ZNS8K6tatuIktZEO3ryp6Vpy4TEU5ezUZelv02Mlic1weKprFSnFpr4r9+zPIv2Z9QlGl6rp8101zJaXjKoZ920ex9K6/41+I5dK8Hvp1ijPqusOLKzQA4LMecnt8oavOf2V7Zra11ZnMafv8AaI9wZ+MjJwe9dZeJqfiz4228E1neW+j6BEJo5HBEVxNIpGQf4tqnHsTXk4apL+zIQSacvd66Xe/yR9Dm1GnHPa1V/DD3u12knb5s7n4f+F08KeG7CySNY5I418wLxlj94/nXVY6Um0rx2FL0xxX0dKCpQjCOyPz3EVp4irKrN6t3H0jfdNGaDWpgZutaTFrmlXdhcIJIbiJoXX2Iwf515h8I9cg0HVLnwROrw3mloDEGPEkJPDAnr2r15hkEY4ryr4jeDr+18aaD4t0a28+7tpfs97GvWS2Y88f7J5H1rzcVGcXGvTXvR/FPdfqe/ltanOnVwld2jJXT7SW337fM9H1yzfUNHvrWLaJJoXjUuOMkEc+1eV/AH4d654J028GrlUaWc7IQ27ai5AOcd/SvX0LEYIwaX7vPYHmuiWHhOrCu943/ABOSjmFfD4Wrg425ajTfy2JqRuhqtJqUEMZeRtiL1LEDHrnmuC1v9oDwZoszwNqRublW2eTbKHbceMdaurXpUFerJR9XYxw+BxWLly4em5PyVz0MgkEVzHjzwRb+NNFltZNsdwATDN3jfHX/ABrH0n47eD9WuBAup+RPnGy4XYfrXdQ3sd0imJw4YcEcj61EalDFQahJSXWzv9/Y2dHG5XVjUnCUJLVXTR498DfhPqXgS41G61OG2iuZ32BoXLFkByDnA6+le0Y70xQFJwMd8U/mjDYenhqapU9kTmGYVszxDxGI+JgzBVJPQVwHij46eEPCd5cWd7qDG6g4lihTeyZ6ZFd8wypBHGK43xJ8LPC/ii/S91LSbee5j6SEYPrzjr+NGIVeULYdpS87/oVl/wBS9r/t6k4f3bX/ABPKviJ+0TZaloV3p2haXNqBurdgZbkqkKqeu7BPaub+D3x007wrpp06/wBMkt4FdnjltyuME8kjOQK9fuPhj4B8O2MpuNPsrWEjdIZDgfXk1f0fwN4NZWms7HT5EkVVLqoYMB05714jwePnXVV1YqS8nsfeLMckp4KWGhhpuDd736rzvYzdP/aG8J32oRWAkuIruVkWOKRV3OX+7j5u9enLKGUMAcGucXwPoQ1CC9Gl2jTx42S+Wu5cdMHHbtXRKp+XPXGOK9mhGvBP28k/RNHwePlgpOP1OEo6a3d9fuHM3ynHBxXKfEXxVN4V8Oz3FtZzXl3IRDbxwpuJduAT6DJrrD0NQMyDhsY/u4repGU4OMXZvqcdCUYVFKUeZLp3PN/hF4DufDti97ft5l5ct5m2QkmPPOBx6k16bg7u1NVhgcbQcU/8Kzw9COHpxpQ2RtjcZUx1eVarux1RSQCSNlPQrjNTUjfdNdJxLRnhkvg3xD4F8fRXelzedoN7eo724z+7LkKwxjp3r21fmUblwxHSkdlX5m4xzk/WnKw7c9s1x0MPGg5cr0bvbt6Hp47H1McoSqxV4q11u/XzMzxN4dg8TaLdaddKGhmXpuPBByDXz/qXg/4hfDt5R4bV9QW6mZmXho4lAwMA49B+tfSsjiONmPQDtXi/i/8AaJs9G8XReH9P0+a8nV9s9xJ8sSDGeCM5Pt+tcWYU8NyqrWm4O+jW57nD9bH806GFpKrHeUZbadTm9L1H406hbyRTWUNteeYohmkCKhXIzuAzwPbmpYdD+NH9o3Utxe2MiRwg+VGSI5n6goSOPTmksf2ktS1K+8238NF7GKXy3ZXPmZBxkDGMfjT9S/aiWRpYtP8AD1yXgyJWkYbYwFOM4z3/AErw/bYFrXFT083+Gmp9jLDZtz2p4Ckr76Rdtv72hk25+OU9ngW8aMwyrO8YZSD0PqK0bPS/jg1zGXm0+NSqlmaUMoweRjHpSaB+0/dXV1J9u8OzC2iRdzWzGSQyMcABcd/rXrPhL4m6N4snltoXNtqFuQJ7ObCyxk8jK10YaGFxLSp4qo35ya/NHJmGIzHAp+1wFJLyin/7czptOW5+wxC7KtcBBvZem7HOK8j/AGoVdfh/G6bWiW5VXBPO0gjj3zivZVfcuRx615L+0xpj3nw3neNsPDLG+7GeM4P069e1e3jo/wCyVIb2ifH5BUUc2oSlp7yPm/4KTm4+JXhyBR8huRPxxxtxuP16V94V8J/BtjZ/Fjw4luRteXBbGdy7eQPpX3X7V5GQfwZ+v6H1/iH/AL/Ra25P1Y6iiivqT8qCiiigAoopD0oAa2cGvJP2kLia1+HFxJFKsR82PllyevavWyflNeQ/tNRq/wAMbgMqt++ixuOMc9q4Mdphaj8j6Hh9J5ph0/5kfN2sa5aalcaA8USyXEUq+d0C8YwT+NfbmgkyaVbFsHKDp24FfCJ0vTtLtbSe8f7VFlQ8SNhnxyRxX3T4Ynjn0GwkiUpE0alQ3UDA4r53JJN1qnM9WkfoPHMIRoYdU72Tlr9zOV8d/A3w94+1KLUb5JIb+JSizwNtJU9Qw71zmmfsu+GNHvI7qOa8mMeSEkmyufoBzXsjTKnXIprTKykAE9u1fR1MBha0/aTpJvvY/PKGd5nh6XsKVaSh2ufJOpfDvTtL+M0OhvLH5U7LMi7QCN3Ynvxmvd774KeHtUE/2m28zzohCPmI8tR0Cf3fWvOvHUMd98cNHvTJH5OnPCJE24bJ5B3d8CvoAXkXBByPavLwOEoyqV4OKaufUZ5meNVPB1KdRqTgr273/wCGZ5v4f/Z18J+Hb22u47Vrma32mNrly5Uqcgj3zXZeM1SPwnrLSNIkQtJSzQHEgGw/d9x2rZF0jcfr2rO8TQvfeHdSt4uJZbZ1XPTJUgV7H1enRpOFKKWnRWPj6mOxONxNOpi6jk01u/M8A/ZoWEeJNcNmsht5PLYySLhmOMDOO+K+jVj8rJbaFUdfb+lfPn7NcK2up6lEZYW2lWCxsSxySSSO2COPY17v4kunsfD+pXEfEsdtI6/UKSK83KbRwSk/P8z6Hir95nEoLryr8Ecl4y+OHhvwXfwWNy893dytjybNFkZRnqfmGB/hWRN+0d4a/t5NLtIry+l83y5JYVTy4xjJbJbkY9K83+AfgTRvGkl3rOp2CXF6s2BK7MSDyW59Oe9e2WPwj8MafcLNDpFrHIqlAypjCnqPxrKhVx2Lj7am4xjJ6J3bSX6s6MdhMkyuq8LWjOdSK1d0k2/0RgN+0h4PE0kayXcmw4LrGhX0H8XrxV3Rfj54R1q7Fst5JbSsAV+0qqA59DmtuP4X+HI1dV0ezVXXaw8sEEemKg1T4R+FdTjUT6LZt5eSm2FVK8Y4wK6lTzFO/PB/JnlupkMlyqnUXndP8LHVQ3sVwMxtvX1HQ1MfTqOteD6TNqvwp+JVnpdzqJvvD2oRiK2WaTm3bdwMY/CvdVYOpYEkexrqw2I9vzKS5XHRr+t0eVmOA+oyhKEuaEleL7/5NdQ5YDPUDn8q4b4nfFCy8A6QZJF869n+SC3yOSeASM9M12t5dR2drPcSHakSFmY+gGSa8M+Hmlj4m+NtZ8Q6vAtxaW115OnrKMqqrg5x9azxdWpFRoUvjnon28zqynCUanPisUv3dO113b2X9dCz4Q8D+JfiHaxaj40vZEjMnmJYW8hSNkIwNwA9O2a7/T/hH4Y0tkeDSbZpEOQ8i5NdhHbiFdqqqr7VJtp0cDSppOS5pdW9W/v2+RGKznFV5v2b5IdIx0S+44bXvg34W8QxSi80m3Jkxlo1KnIOQcjmuX17wXr3w7086l4Y1Ce9s7UrLLpV4xm8xFHIjYjKn8a9iqKSPdGVYAjGKqpg6NRuUY8su60f3qzMqObYqDUasueH8stV+OxxXw3+Kuk/EbS0uLF2FwNomt2ADRtnBBGfUH8q7dT164ryrU/AeraH8SNH1rw1b2sdlcyeVq0f3QIwMhlAHXp+XvXqaqcZxinhnVt7Ot8UevR+f+ZOZU8LGoqmDfuSV7X1i+z/AEfYSWYIjk/dVSSa8Sn+LHiXx54km0nwdp0cVpbzGOfUbx/k4ODgDPp712Hxq8XHwb4AvbqL/j4uALaLnGGbIJz24/XFYn7OcY/4QG0kECxMZZMjOT985JOOTXFiKk62JjhIS5dG21u/JdvU9jL8NTw2X1Myq01N8yjG+17Nt26mff8A7Ot34iiL614ovLq6d8u6sdvl9dgGOPrUOn/swpoqK1h4r1iylhJMLW82AgPUFSCD+Ve6UN901p/ZWDvzOnd97u/33Of/AFkzTk9kqto9rK33WPIn8Y658OtWtrLxCou9DlKwx6whG8MegkXsD616jZ6hDfQJLA6yxtghlIIIPesL4heFf+Et8J6lpoVHmlhPlFx0ccqfzrK+D/hXUPB/gnTdM1Fw9xbqUOGLd89aqn7WliPZPWna6fVPtfdmWIeFxWDWJuo1U7OK6q3xeXZndu3yntXhPx28Qa3o99am1lMUIwySRyOhDZOM44PI6GvdW+6a+ePjxJcHx54Ytru+ePR7uZUe1AGHYMd3zdR8oFRmrccI2r7o6+F4RqZhFTimrPR+Sv8Aeen/AAx8dR+LtAgadg1+mEnVeivXcq3txXiHjDTYPhBNa+LdJDR6crpDqcEaly8eQA4HYjv0yK9X8N+KLDxRp8N7Yv5kUqgg/wCeh9q0wdWaXsKz96Kv6ruceaYSF/reET9lJ/c+qf6eRuU1/umnU1vumvTPnjyX9oTXNQ0fwnavZXJtfMuljdlOGYYJAH1IFeheF5nm0OzeTJdokJyc9q8//aI0Zta8BbI1BlhuI5BlsEYJyR9M5r0DwzH9n0Wxh3CQrCi7lOQcAc/SvKhGf1+o3tyx/U+nxHsv7Jocq97mlf8ACwniy6ax8M6lcK/lNHbu4f0wpOa8T+AGlWWtSazPc2UT/wCl/I0qK/OMkrxwDn+de0eONn/CH635sJuEFnNmJcZYbDwPc14l+yvczXNnqjO7MnnoEViPlG0nHHua58RrmFBPz/I9LKk45JjKkNGnE92g8N2FszGKzt48jHyoBx6dKZH4X0+AyGOxto9/3tsYGfrxWzSV7nKux8d9Yq/zP7zMg0G0tVIgtYYs9Sq4P415j8avhnY3Gi3fiSzAstZ0+MzC6hJRnA6g468dM17B7VyPxWkC/DvxASGINo4G3qT6D3rixlKFXDzhJXVj1MrxdeljqUoy1ckn5ptJo534FePH8beDbaW6dZL2HEU2GzyOhP4Vd+N/nyfD/UoIHt0MqbW+1NtTbn5hn1xmvOP2S4y3h7UXCMim5x8/UkAZzXRftN/Y5fBEUd3MYP8ASkkjxzllBKj88V5lGtKWU+0nq+X/AIB9RicFTo8T/V6KsudW8up4V8FbFrf4qaPI1ugjjYqxwSdzKcYHYj2r7dU/rXxv8Etk3xH0iQS+bKTIWMnzFflwPxI719jrWWQ29jPtf9DfjybnmFK+6h+rH0UUV9MfmgUUUUAFIaWigBh4ryX9pHy2+HMxkXcnnxAr/EfmHAPrXrTcg15V+0ZF5nwzvQY/M+dMAduetcON/wB2qeh72Q/8jKh/iR83ahb6VNfQQpbzxW6lGMJI3buNx+mK+zvDojXQLAQNmPyk2tnORjg18J251PUL62tTAxnhcBlj++3HzKCevy9q+6vCq7vD9j+68n90v7s/w8dPwr5vI3zV5yt0R+icc03To4eLlffrft+Z5/8AFiz+IN1e2sfhsoLEnMrwyKko577uo+lcJpMnxet7sCayleGPdjdKv70443e1fSZjPXg+lHlnnpjsK9qtl3tKvtVVmvR6Hw+Fz14agqDw9OS7uOv3ny5q3wl8f68yanOyHWJGzJiXamP4eg429O9GseC/i7vhgtJpVSPH7yO8AB+uRX1CSUXJ7DJx9KajiTAwD65rneT0pXfPK73d0elHi3F6Xo02o7Xjt+J83+FfBvxjtNRU/wBpRQRKw4u5vMTGeeAvNe6eKLW+m8F6pDFMqXzWkio46BtvBroFUgjIAFVNbsX1DSbu3QhXkiZAT0yQRXZQwMcLCUYyk793f7jxsZnE8xxFOpUpwhytfDG339z5s/ZbtLi38S615wDOscazMBnEoJBXPcYAr6J8WW5n8MapGerWsi/+OmvMPgj8MNa8G6jq99q5hRrmbEUcTEgIO/Tqa9T8VSSJ4b1RoUEkotpCiN0Y7TgVz5dSlRwXJNNPU9TiLF08ZnKrUJKS93VbbI8Y/ZriNrDq0IjwqzqQyrgN8vXGfaveh1r56/Zo1CC1s9QgnmVrlpPNJ3csuTg7e2K9/wDtcR5DcZ9a0yjXBwt5/mc/FMJ/2rUuu35Is0ybPlPgZOKi+3Q/3v0qtqGuWWn2ks9zMsUMalmZuBivYeiuz5WNOcpJJanzv+1Krzar4bSOFpriRmSIoSDu3LgDA+vNfQmjxS2+mW0b8yKgDfgBXiUN6Pi98W7K508ONI0Jgfth5S4bqVxjjnvXvijaMDHSvCwUVUxVfEwleMrJdtOp9dnVR0cFhMBNWlBNtduZ3S+78zhPjJqE9r4FvoLc7Jr5ktA+QApc4zn05pvwa8F3PgvwfZ2N3MlxJuaVnQk8sc9wO2K5n9pi9lt/AKQJatdrNMAyxnDLtUncPpXongW6a58L6XKQ677eM4f7w+UcGtVyzzGV1rGKt83qZT9rRySCj8M5tvvdKy/M6WiiivYPkQpG5U96WigCPy+AO1Ky/IR04p9IaAOX+IHg+Hxx4YvtKnAImUlG/uNj5SK8z+A/ieDQ1vvCN3ut7nSZzbq0pAacZzuAzk5J9K9yZNykY61x3jD4VaJ4yEkt5brFekfLdwHZKv8AwIc15lfDy9pDEUbc0b3812ufRYDH0lhp4DFt+zk001ryy7266HXfakb7oLfTFOEyt2Pp0rxS68FfEfwTpco0PxBa61FFkwQX0RM23+7v6e3P51Bb/tDy+GtQttO8aaFfaTcsitJdRqGgJJxwc4/DP51DzCFOSWIi4eb1X3q6+9o1/sKpiE5YGpGquydpf+Auz+657pt7dqTZt7AeuKp6frdpqlrFc2snmwyqGRlxyD0q35y9O5r1YyUldbHzcoyg2pKwknCtXzV+0JHLN8RvDCB127VIWQ4VmEo4HvivpaTGxs9Mc180ftBWI1D4kaBGZlEghVo4342MsqksD0zivFzj/cpJ9WvzPs+EbLMU3/LL8j6Dk02DUtJltJollgmQo6sOCD2rwvwxDc/BD4if2PcKf+EW1e6zZXGS2yRhnaxPT6177p+VtEHBOPWsXx94JtPG/h650+6+TcN8cqsVMbgcMD7V0V8O6sI1KX8SK0f6ejPNy/MI4eVTDV9aVTSXl2kvNf8AAOijukl+7kjseKlZvlPHavFPhH44u9IvpfB3iGZn1O0cx280indcRjoTxjOK9n3ZUgqQMdK6MNiI4mmprR7Ndn1PPzDAzwFb2UtVun0a6Nep41+1Cls3w/HmicztcotuIXK/vD0zjtXpPgu3+z+GNJjJLbLWJck8/dFef/tHWUd54TsHlmEEUN6khbfgcAkV6R4ZYHQtPxyPJQ/oK46cf+FGrK32YnsYiX/CNh0v5p/oS+IrV9Q0HULeKTyXlgdFkP8ACSCAa8R+A2sWXhiTUtG1G+tRqEd26tGhC8g4H1ONte3eIvNXQtRaEqJhbybNwyM7Tg4718t/CPwlZeOLrxHplzEtpeGVZRdqctknng+v8q58dKUcVQdKN5O++2x6WRUadbLMXGvK1NON7Wutd/TyR9UHxBp6qzG6jUL97cwGPTNEPiDT7hlWO6jZm6AMCTXj6/sw2bKon1u8k/vgMAH9N2Qc1nf8MqeXcSTp4kuFk5Ee0FNo9PlIrZ4jHp/7v/5Ov8jijl+SSunjWv8Atx/5ntt34j06xWR7i5jhVF3MZGC8evJryf4yfFTT5fD76LpEv9pajqg8iJbUqxwWAznOB1475rxXWPhnquj/ABItND1e8eWy1CSKE3LSMVlQnoM55B9RivqHw78K9A8N6h9ts7CEXbABpyMtgdgT0H0rkjiMVj1OhGCp20d3d/Kx6lbL8syOVHEyqus5LmjZWWm13r1K/wAJfBv/AAh/hG0tZIwly482bBz87cnsK5b9pCzt7vwjau6+bKl0AkQyWYkEHHvjNewsvykY4x09a82+N2k29/4ZiuGn+zS286tHIZNmSQV2/jmvQr0FTwUqMdkjxMrxs62cQxVV6uV/vPmn4N2bWvxO8PPETtWbYGz2KHOR35719xjtXwn8P/G1p4b+Kvh/RbyQB49QWFhHGWO5h8oJ/u859utfdSShlBXoelebkSSp1En1/Q+l4+cpYyjOW3Lv82SUUUV9MfmAUUUUAFJS0lADW6GvMvj8w/4V7dJyGMiY9Djn+lemnvXlP7Rkhj+HMzjkpLGD9CcH9DXDjf8Adqn+FnvZGr5lQX95HzH4b1q6uNUsII2RLhHJhnkXBJ75Pf0r7c8NI/8AYdiZW3SeUpJHc4r4H8u40vUIpTIcSMJePmIA9B2NfefhGQ/8I3prElswR49/l618zkNTmq1IveyP0jj2lGMKE4Ws7m7u9qjaZdhOOPWmyShEZm4CjJ9q8K+NnxvOlbND8MXCy6xK6xzMq7iin+FSDy/t2r6nE4mnhaTq1Nl+Pofl2W5biMzrqhQjfu+iXdnS/FT4xQeD4YbWxtpNQvZmAkEDDMKHjd1/KvK9J+K3jHwFqkVx4jtrqfQ5Tkboy0gQnIYkfxe1dd8Evg9c2cI1zxPAlxrE53bbhjI0a5yASffp6V7XfaRBqFrJb3EMckTLgowyK8eNDFY62Jc/Z/yr/wCSPsJ4zKsnbwEKSrLacv8A5He1u/Ur6D4osPEWnW97YzCWGZcqV5rX35GAOa+ctU8I658F/FR1zS5Fn8LSSIr2QJ/chmA2hemATncTXtvhnxhpviq18+xm34IVx3Vu4xXo4XFurJ0Ky5ai+5+a8j5zMsshQjHEYOXPSl16ryl2f5nQLHt6DH0NU9chE2i30ZLANC6kqcHkHoau7waivF8y0mXAOVIw3Tp3r0GubQ8Gm+WafmfIfw98F3PjbWtVtNLlXSkt22i5Z2MoBzgAr2B5r060+Bfiuxg+zQeNJ47cNkBmdzk9evX861fg/wCGtN8M69rdvbSg3U0guHhz80YJPBx7167zXzWAy2lKipVV713s2uvkfoed8RYmGLcMO1yWW8U+i11TPAbv9m3X7tsv40uD0OC0hGfXG6rOm/szXH2VbfVvFF3fW2fngVmCtz7mveKK7/7IwV7uH4v/ADPElxTmrjyqol6Riv0MHwx4O0/wjZLaabCsMCjGO59zW3tOCeM0+kPQ16sYxglGKskfMVKs603UqO7fU8t/aC0e51D4a301pKYpbLFwWHUoOGA98Vr/AAi8RxeJPAOjXUJZlMKoxcYO5eD+orqdc0uHWtIvLK5TzIbiNonXPVSK8j+B2p2/hu61PwfdyeXqFhcu0du3XyWOVYZ6jrXkzi6OPjVfwzXL81qj6jDyji8mnRtedOXMv8LVn9zse30U0Nk4waXNeyfJC0UlNkPykYPSgBPOXaDzilWQNjA47V5t8UvEN3I2n+HdGupbLW9TkxHOgB8lFOWcj0xXf2EcsNpGsz75FADv/eIHJrnjWUqsqaXw7/5HbVwsqNGFWb+K9l1stL/eXaQ8giszXvEmneGdPa91O4W0tlIUyP0yTgfrVmx1S31G3jmgffHIAysOhB6GtuaN+W+pzeznyc9tO5O0ZI46461nan4fs9YtnhvraGeNhgqy7hj8a1aRvumnZPRihOVN80HZnjWvfDjUPh7Hea74OupVKIWl0qZy8LqAT8gP3Tx2rp/hZ8S7f4iaHHdLEba5QhJ7c/wN1rtbhcQvkcbTnua8E/Z9BXxd4nSO0ms7Zp/M2TDDhskLkduP5V4co/VMVS9lpGbaa6X6NLp5n2FOazXLsRUxSvUpcrUurTdrPv5dT6CPQ181/tKQwW/iLQZZmjf7R+4CbjvjUSKS6jHXnr2r6Tb7rZr5p/aWvmk8UeH7eCHdNEjPK/lglVZlUANnp61WctLAzv5D4Sv/AGpC3Z/kfQ+jbTptuQSU2Lgn6VoN90/Ss3Qc/wBk2gbk7F/kK0q9en8C+X5HyVbSpL1Z5F8avh3qepxQeJPDYjXxBpjCZEYZ+0KvzBM545HFdF8L/H3/AAm3hiC+li+z3hGye33A7HBwR+ddvLF5itwCcd+9fPPjTR9T+DnjlPE+j27vod9IBqMaMWWMZ5O04C/WvJxP+x1PrUF7r0kl+Evl18j6rASWbYb6hWa9pH+G3+ML+fTz0Og/aim8vwLZRm3M5e9jKgnADDJUn2zjNemeC7hrrwzpkrBQzQRsQpyOVFeR/tGeIo9S+G1hNbOHiu5l+ZcNgMjHOenFenfDNoj4K0Uwlin2WLBI5+6KVKopZlPle8Ua4yi4ZFQclZqc/wBDodYhNxpN5EsrQtJEyiRPvJkdR7ivnz9mubzvE3iFI5vtEUbqPMkTa7Nk5JOK+htSZUsLhmyFEbE469K+dP2c1RfHniiSMYhlZWT8yCaWMssZhvV/kVk3vZRj/SP5n0tTW5UinUjdDXuHw54X+0pp7WdhoPiCDIk0++TcR0wx4z/wLFel+A/Ftr4w8P2uo2pYrKg+8ACD3B561a8ZeGYPFnhu/wBKuEVo7hCPm52t1B/PFeLfAO4ufC3ibV/CupXMMk8UnmKsJ43A4YDP4Hp0NeDUcsNmCm/hqafNH3FONPMsllC/7yg7rzjJ6/cz6FJ6+leWfHLT5NatdA03aggn1KNpGl+6uwFgfzAr1Ld19M4rzL9oTWL7QPhre3mn4FzHJGA3lbyNzBTt9DgnB7da9LGW9hO+1jwcmcvr9JQ3bsr+el/keG/DGO30n9oTVtOm0cNBd3RuLO+mAzkKM7B/dGMZr6/CnPv618PfBOS61T4vaFLKZlddzdT8wA5zmvuPaSa8jJZ+0hUkla8v0PruOMP9XxlCDld8iv63aH0UUV9Gfm4UUUUAFJS0lADGOVNeWftGK6/C/UJEx8jI5z2APWvVNvBryT9pi4SP4W3iO5j8ySJQ2OMlu/t61w43/dqn+E9/IU/7Tw9v54/mfMmnx2Nx/ZslxqCrPMdpx8xXHtX214XEUXh3T/JbdCsSAPnqAvWvjLUPGmiaxoNppi6LJp7WibkurdAQJMfNzx9a+pfAbXupfCu0TT7lBfS2OLeeQblD7SFJHpnFfNZNKMa8lGz92+mm3TX/AIY/SeM6VSpQozqpw95qztaz2d15GD8cPitbaHoN5o+n3JGr3aGBTHtYxZHU88HB4zWR8GfgjZaKmn6/fNNd6wyBzHcSB0iY9XAI5Y+tZfhL9mK9vZ7i78balHqF07kgWcjAHJ6sSoz9K2PHlj43+HZgk8MTtqGibBH9iaLzZIT0BDdce1dFqsqv17F0m4r4Y7tedjy+bCUKH9kZViVzy+OT0jLTZPt6r5nt6sF4AUDPO2ntL8pAXJr5i0v4mfFS6Wbfo9yzLwoFkVH5mnRfED4xtBl9CYKr5LeQNzL6Y6V1xzmjLVUp/wDgP/BPGlwliU2nWp/+Bo+kby3ivIJYp41mikG1lZeCPQ180eNLi7+BPxETV7adbzTNSU7rZ2Iwc5OeygCres+I/i/PcSx22mymKSNSgWJfkb6nGK2NC+BuseOZTqnj29825kTy0tLdyBEPUnHJrlxVaWYJQoUpqcdVJq1vmetluEpZKpVMfiISpTVnGL5m+3pbuev+D/F9v4u0mC9t1ZBIPmRiDtbuODWprsnk6LfOWZAsDtuT7w4PI968/wDAPwZl+H3iSa5sdWkl0eSPH2OYlmEmc7s9OlejahC01jcRhgm6NlDehI617uHlWdK1aNpL538z4fGwwlPFp4OfNT0a0s15P0Pnv9m/dJ4o8TTAyeS8iEee2ZOckZ/PpX0aK+fP2ddNjsdX1xEkmnPn/wCumHPU8Z78Y+lfQSt14rjylNYSN97v8z2OK5KeZya2tH/0lD6Kj85d2MHNO3fhXsnx9rDqQ0tJQIYykqcdccV5F8Wvh5qc2raZ4s8NhE1nTT+8XH+ui6lCO/TivXzwp/xqOQblIIycelc1ehHE03Sl1+9dmj0MDjKmBrKrT17p7NPdP1OB+HvxY0/xfYsJ91hqUJ2XFndfJIjeuM9DXdrdRnkNkexFcD8QPgzovjyIytH9g1Lbhb6AFXx6Nj7w9jXmUnwo+J3gu2ePRvEi6rBnYI5JX3IvZsNkZ+lee62KwqSqUnUS6x3+af8Awx9FDA5ZmN50a6pSf2J3t8pLp66n0ebhQMkED1OBXE+PPizovguxk3zrcagwIitY2yzNjgcdOa4DTvAXxN1y3MGpeJ4tKtlcYe2z5z+ueMYrtfCXwe0jwvNPdNu1K9nIaW5vj5rZHpkcCr+sYnER5aVJwv1l09EtW/wMHgcuwMubEV1Ua+zC+vrJrT5XMj4YeHtV1zUn8WeIofI1CcYgtSc+RH2x7mvWNp/CmRqsYCqoUDoF9KlbOOBXXh6Kw9NQTu+r6t92eJjsZLG1vaNWWyS2S7I5rx94XXxd4T1PS2CZnhIQtyA45U/nivMvgf4ztNB0+Lwlq8klnrNnIY1huWGXXPBXJ5zXuDK2GxjOOK4nxx8I9E8cOlzdw+VqMQ/c3sR2yxH/AGTXNicNN1I4ihbnj3+0n0v08j08ux1D6vPA4y6pyd01vGS0vbqu52n2pNuRz9MUgu0ZScMPrXijfCPx74dszFovjaS8hVNqxah97jkYcKeT0rG0X4Y/FTU2Eeq+Lm0+DzMloW8x256cDj86zljq8WovDyv5NW+//hjqjk+CnFzWNhZd1K/3WPWfHXxI0XwTpcs1/cEyMNkdvD80sjHgBRnPJ71m/C/wrJo8N5qNzJ51xqNybjc2dwjxhF5A6D9Saj8JfBPSfD92t9fM2t6ov/L9fnzZPw3fdH0r0FIWXg7QPQGuinTrVKirV0lbZLX7339NDhxFfDYajLDYOTlzfFJ6J22SW9vUezYVvpXzP+05JPa+IdGaJ9jNEVRVzuYlxgYx0+tfTLKe1cb46+GOn+OrjTbi83RyWM6zq0ZwXA5Kn2NLH4aWKw0qMN3Y14fx9LLcdGvX+FX/ACN7w+skek2qy/eCDP1AFag+aoYVEcaIPlHSp8Gu6CtFLsfP1Jc83LuBXis/WtIi1jSb2xuEWSG5iaJwR1BGD29K0qRvumqaTVmKEnTkpR3R8T/EDw3qng3UJNC1IvfWMKEWLSyHY0WT0B+XcAcdBX098IpGfwHom6PYBbRgL6fL0q548+HOlfELSRY6rBuRSGV0OGUj0PpW1o+jw6NYQWUCgRQKsaLnoAMV4ODy54XFzqJ+5ay7/wBI+3zbPqeaZdSoyVqid329V69SfVsNpl3l/KHlN85/h4PNfPP7NNzbXHiTXNkbCbC5mfrIu5iDjt1r6OmhE0TxsAVZSpB561x3g/4W6N4H1LUL/TI5FlvJN8m9ywA9Fz0HtXZiMPOrXpVIWtBts8rLsfRw2AxWGqX5qnLy28n1O3pKj+0L7ijz1YcA/lXpnznKwkJVT3HevAfjRpo8EeONA8ZQloIZJlt7oxgAAkggsffpXvZl5IrA8d+CbP4geGbvRb4FYp1BWQHlHHKt+Bwa4cbQeIouMV7y1Xqe3k+NWX4qM6nwPSXnF7mtpmowapYxXMMiyxSKGVlOQ2RXF/G7UdU0z4danLpcdvNdsoVRc/cCscMT9BnFdF4P8Jp4R8N2GkpK1wtpEsfmseWwOtch+0Ppv9qfDG/iaRoVVkdmU9NrA4PselTXc/qknNWlbX1Ly6FH+1KUIO8OdWuul+x85fA68urH4u6THcyJJJKrIwB68Zzjsa+3RXw38C4c/FDw8PMTOXZdvGVCnnntX3IOteRkV/YTbfX9EfYeICSzClb+T9WOooor6c/LwooooAKSlpKAEY8N9K8g/aSgFx4DUPI0Uf2ldxUAg4B65r15u59q8k/aUVT8NbospYLKrYBx6j+tcGO/3WpbsfRcP/8AI0w/+JHyBY27yTpHG8cbuNqySsVVmz169xx0r7n+Fenf2T4H0iAlW8u3QfL06Zr4Zj1iRvJMUQtpVUKPKIDFTx3Br7h+FtnfWvgXTEvJ1muVtlBkxyeO/r+lfKZFZ4mTX8v6n6vx/wA/1WlzO3vbfI7J7mNVOccdaRpoz1INeF658P8A4n6l4rvL6HWbeC0iP+iotw6o49GUDisNfhv8YLdb6JNXt3Q/vFkkunJdz1A46fWvoJZhVi7LDT/rqfnNLI8JOKbxtNPTq/8ALofRgki6BV9zilaaNeTtH618p3Xhj4r+B9N1K+e4uJkjUTFre680gd8KwHSue0/WvHfxAvdOtk1a4S4uSRHH5vlMMDJYkDtXNLOuS0Z0JJvoexT4RVeLq08XB047u/lc+zlnRcD5RzwM/wD16d9qj/vV892Pwx+Kl5ayw3OvwWKKf3f+kOzNxwSwFZmsfBv4tXKGNvEUFzExBYxXUkbHHqcVtLMaqjzLDS/A8yORYGUuWWPpr7z6bW6jZsA80txGLiF4z0YbTXlHwf8Ah54s8Jx517XBeJgKlsrvIF99zc5r1k5XJr1cPVlWpqcoOLfRnzGOw9LCYh06FVVEuqvb8Tifh78M18A/2h5d9JerdXDXA83rHn+Ee1dnI5WNm46Upk4OQRiuJ+Lnih/DHge/lg3m9mQW1ssf3jI52jH55qf3eDpNpWihqVfNMVHnd5SaV/wPLPEXxZ8QR+P0vbEtL4WsbgQSrCgIfs5POc56duK9+0/UotQt4J4TlJQGXuDnnNeT+GPhD9n+Hskdx+91a6t98kzuctIRkdh3xSfs/wDinUrrT7zRdWaOa90uYW5lh+6wxnGPUY/IivIwc69KslXd1Vu15Pt9x9ZmmGweKw0p4JL9x7r6OSf2vPX8z2mkPSlpD0r6E+BGMw2knj3rzr4lfGbSfh+yWzRtf6jIQVs4WAIHHJJ4FehyE7GI9DXzpHo+neJvj1epe5maCTd5UiZViqKBz2xmvMx9apRpxjRdpSaXpfqfSZHg8PiatSpi03CnFyaXW3QvWP7UkMymefw9dLB9o8nMbqWHuQcDr6E1D4j/AGopLG8NraaG8RUbmmvmCr+GM17n/wAI7Z+WENnbFc527OM/lRceG7G6/wBbZ28v/XRA1c7wmP5eVYhX/wAC/wAz0Y5hkkanM8E7f43/AJHg2j/tRXN3OsT6BJdpuwWsX3ZHbGRj9a3x+0dHLazXEXhjU9kKkyblUHPYL6mvW7Xw7ZWR/wBHtLeEdPkQDj8KsNpcTKAY4yB0BGRThhMdy+9ib/8AbqIrZjk1SV4YKy/xv/I434a/Eafx9bzyT6HfaOYZNgF3ghx1yp6/pXej6VHHbiPoqg+1S9K9SlGcIKNSXM++x8viqlKrVcqMOSPa9/xYbqjkuEjUlztA65xVXU9WttJ0+4vbmRYreFDI7scAADmvHftt58dlubeznnsfDQnG27gcxNcKG+ZQRng8j8awxGJVFxgleUtl39ey8zrweBliVKrJ8tOO8v63fkdp4s+NHhXwfvjvr/fOF3CGAb2OeAOuOT71znhT9ozRPE9+0RsrvT7fkrcXAAXjru5+X9a6my+EPhuzjQDTYJHVQhkkG8kDpnPU5rTh8B6PbwyRJpln5bncymIEE/lXL7PHymp88YrtZv73/kerGpklOk4eznKXe6X4f8Esab420TWJ2hstQguZV6pG4LflmtgTK2MdD0NeQeLP2d9P1CY6hoF7NoGqR5eNoHPlM3Ublxnr/wDqp3w/+IF5pHiVvBvim6WTWokVo7kLtS4U+me4qo4urSqKnioJX2kndP8AVMzq5bhq9F1suqOfKryi1aSXfTRo9gLAVheM/Flt4O8N3mq3KsywoSqLjLt2H4nFbHmCQHaDyK89+O2nnUPhnq6I6o8cYk+c4zg5wPc124icqdGco7pHlZfRp18XSpVfhlJJ+jZc+FfxET4iaCL/AOzPZzJIYpIW5AYY6H0wa7n0rxz9m3TZbHwTF5yrG80zShR/CPl4PvXsdc2AqVK2GhUq6ya1OvOsPRwuYVaOH+BNpD6a33TxnjpTqbJ/q2xxxXoniHmvxM+M2nfD2+srGS3e6vLkghQcKiltu4n616BY3IvLWKcDCuAwH1FfNP7UMCQ+J9BkEbPLKm3CDqofOG9evFfRugr/AMSmzOMYjX+QrxqGIqVMbWoyfuxtY+tzLL8Ph8swmJpL3qnNf5NGmffpXNeOrzWtP8K6hLoNst5qccX7mJjjnuRxyfrXTHoe9N8vt1HavWlHni43sfLUpqnUU2r2ezPkL/hNPiLJavJJca4moh9rWosUaIc9jjp+NLqnxV+IGj3unWt1diN5cZjMKhnJ6jp1xX1o9v1O1a+YPjBNCvxw8Mo1tIFjuYWLEZSYtjnPsAK+SxuDq4Oj7RYiW6W7/wAz9dybNMLmuIlRlg4JKMpbJ7Lbb/Mfda98XriLzraC92ByI41t4wSDwCxPvXsfwhPi2Xw+s3i35NQeQsI/lyq9gcDrXc26/LwB75FTbTnPGa9nD4F0KiqOtKXk3p+R8PmOdRxlH2EcNCHnFaiscKTXnvx2ihk+GertcorwRxiR0ZsFlU5wPU8V6Eehry79oxYG+F9/58TSLuj4V9uPmHP4eldeLdqE/Q8/Jo82Y4df34/meBfCHxFZ3PxK8PR2FglpFI7Ls2dFCcAH619njrXxV8A9PW5+JOjzRzRpFbhgFkb5mJXBwK+1hXjZHzexm33PsePI044+lGHSH6sdRRRX0p+aBRRRQAUUUlADW715l+0Bh/hzfDIALL94ZGOtemN3ry/9oIE/De8wu47hxnnoa48Z/u9T0PdyNf8AClQ/xL8z5ps/DFpD4fW/iWHEMysx5dyMj26e1fWngjxJBc+H9K2I8zTRAZiUbVwO/PFfL/hHS5b7w1Jby3iRRurO7AZdcdPmr6H+DNqNM+H1kWYMyqzl88nB65r5nKE/aqysnH9T9K4u5alD95LmlGdl6Nf8A7+61G2sIxJPMsIyB+8IHPpWY3jjQRcC3/tW0M+C3l+cm7AHJIzwBXzYzXX7QfxE1HT59SmsrKy3CGGInCgHG5vrXUL+yHF9pQjxDMsCk42JiTn/AGjnj24r0I4/EV3J4WhzRTtdyS2PmZZDluBSp5ninCo1flUW7X21PXPEHjbR18L6hdQ39u0axMiurgruwcA/jXz7+zrYXreN55bpBOmGcThg2GJOcY6DFdkf2TYR50SeJLtLWTafKPIVgeoHSvTPh/8AC3T/AIe6f9ns2aZydzzyHLOe+eOKmVDF4vE0514ckYdmndnQsdlWV5fiMNgqzqSq23i1Zep1d1eQWMLSzyrBGoyWcgCuej+JXhme48lNXtXl3+WB5i/e9OtL49+Hth8QtHGn6jLcRQ+Ysh+zSmMtg/dJHUGvKNW/ZR08STXVlqs1uI/nggCgqhHv3J9a9HE1MbB/7PTUl5u34f8ABPnMsw2U14P69XlCXS0bo95iuopkUxncD0K96mL8Hgmvmn4C+ONU/wCEuufD1zLI1qpby453yybTjK98H0r6Wb5Vz6DNaYPFLGU+dKzWjXZnLnGVzynE+wk76XT7pjWZdrZHyjrXjeoa9beOPjHaaDFulh0eP7VMxPy+bkAKcccA16N428RQ+F/Cmp6nMSoggZ1wN2WPC8Z7kivJv2afC/l6fN4hkId75iFcgh2XcTuOfU4/KufGTlUq08LDq7v0X+bPQyqhGjgsRmFTeK5Y/wCKX+SPdWUshXoPbtxXiXiqGX4f/GTS9bDRW+j6shtrtgp5kBGz2H1r3FlO01xPxX8JyeKPCdxHAVF3D++iOMgkDO38elb46k6lF8m8bNfI4MnxEKOI5KvwTTi/R9fk9TtIbhJo1dOVYZBp+6uC+EfipfEnheHfIJLu3Jt7jbgBZE4I613Y54xXRRrKtTjUjs0ebi8PLCVp0Zbxdg6g+leEaJYxR/tEaoyRrFth8zLE7pGZUyQPQCvdnztbHp9a+fLe4fTf2k7kTXKrFNApSKQc4KKMq3plTxXn5ltSfaaPocgUpRxUYv8A5dy/Q+iKKrfboezD8x/jTheRN0YfmK9mz7Hy3LLsT0VB9sj7nH1xQLyIkDd+oosxcsuxPTZDhGPtTVmVuhyKVnwpODSF1seTfFDXhrXiLRPCNnceXdXcyz3DbQyrEhDFHGejYxg9q9H0XQ7fQrOO2s4I7aFOFjjGFAzngdq8Y8N29v4v+P2r6kIY1j0mL7Mk0T/M7kkHeB1xjg17yoK8V5eEftqlSu11aXov+CfS5tFYSnQwkP5VKS85a/grD6KKK9Q+ZGMp5xivPfiR8I4viBeaPejUJNLvdNuVnE0CgmRR1Q+mfWvRaQ9DWVSjCtBwqK6Z14XFVsHUVWhK0u/roVooTFEq7txXqT9MV5d+0lZXN58NboQKzbZYmdV67dwH8/0r1dl65rz/AOOkV9N8NdYSzkWJ9ilmY4+TcN36ZrnxkU8NOK7M78mqOOY0J9eZb+py/wCzVrVzqnhaf7T/AK2O5ZG49AuK9q3DjFeMfs025/4Qszl0Zpbh87T34HPvxXsw+9WGWNvB02+x18ScqzWsoKy5h9Nf7p+lOpsn+rbHXFeofNo+Yf2kLu6bxtoMKbjHGySBdo2kZ55+tfR+kNv0uzYcExrx+Ar52/absrhvEGh3MUirGsDLjOCW3qVAr3/wsJP7FsRIfm8pc/kK+fwd1mOIT8v+AffZxyyybASXTmX4m3SUtIelfQHwBHJ8yN+NfNnxWureP4zaPDLazzTfuVjkIPlKS3btnAr6UbhW7185/GbUZYPjL4LV5hDaRsrS5+62WKnIx154rxM31wy9V+Z9pwrf67NJfYn/AOkn0PbD5c1OVNRW8iuisvKkfz6VLXsdEfGy3YjfdIrzX4/NEvw0vxNDFMuUAExwFbPDZ9RXpLfdY15/8bPL/wCEFuGlhjuYlkjZ4ZP4lBGQPQkdK5sWr0Ki8j1sndsfQf8AeR88fAPRzD8SLae4aOW5hJUuRj5iPvj6jivsjPNfF3wJWJfixZPbRvFbzb8RscleM819pCvGyPTDyS7n2XHnN/aEG39hfmx1FFFfSn5qFFFFABSUtJQAw9Ca8q/aGkuLf4ezSQoHWORDJzzj2r1ZvutXkP7Tl99j+GNypyFmmijYr6bv/rVw42yw1Rvse/kKbzOgkr+8j5v0241DWdGuIBPDZWxBTyx8rt3HIr6i+FGny2Pw3trdnSaUQEZVty57CvluPQrdvDdlq1xM0MG8b1RvmlGOhHavpz4Ex203w7s0tvN8lgyq0hyx5POa+WydSWJSl1iz9U4wcfqSlDZT10669Tyv9muya3+I3iSSeT97GoiaMj5vv5yfUehFfU3mr718u3nhnxb8GvGV7qGmac+t2NwWYTqN2FJzhuhBHoAc+taNr+0F42mspSfCLrMgYqZIpFVlHU/5FdWBxdLLoPD14yUrt7N9e54OeZXXz7ErHYOcZQcYr4kultmfSRmAz8rf98mka4UdmP0FfMum/Hrxxqqz3cWgqtpAcMqwSFjjrjOKSb9oLxeZrmJNHDvHGGVFtpSMd8nPXFd39tYW17S+48P/AFQzDm5bxut/eR9OecvYEnOKjuJg1u+FbGD2r5kh+PPjyR3nTw/LLAEMjJJbMFVQOcY5zWnb/GLx/e6a0Z8OxyzyxlwxR0BU9B060451hm/hl/4CxS4Tx1Ozk4f+Bo5n4VziX9oPUnRGm3TTs0jEfuyDjI9M+lfWTklDxXzz8C/hPrGl+JZ/EmrxrZ+YpCQbiXbcckvxz7V9BXEyw27u3CBTk9sYzmnlNOcaUpzVuaTaHxbXo4jH040JKShCMW13R4p+0xrV1F4b03S7KaWC4urpC5BHlmPoQxP4H8K9F8C6VY+GvDVhYW7YigjVF5yTgZrwPxFpWqfHjxhejSplk0izk8hpJn2xuQemBn259CK17P4K/EOGbyf7ZsjaxIYog08mdhPUjb17cGuKGIq/W54iFJyT0T9N/vParYDCxy2jga2JjTnG8pJ73e3zXbzPor7dF0yfyqK6v7dbeUyNsjCksT0A9TXz7p/wF8aW8Rhn19DHsIXyrmb5WP16io9Q+B/ja6sbi1/tO2ltm6W8tzJsLDox4zn26V3f2hibf7tL7/8AgHhrJct57fXo29GXfhj4y07SPiZqGjQbUt7qVvL8oAh5D82489SBX0EG5P1xXydffBfxb8OzZ65aR21xPZ/vTJBIzeWByc5UbhgY+hr6W8H+II/EWh2V8jrIs0Syb1HByOf1rLKqlRKVCtG0t0vJvobcT4fDSdPGYOanBrlb/vL8rr9TdYfKa+ZviZ4RuPGHxmFpYaqLO7W3jk8ps/LwcMCBlfz5xX0y7fKe3FeEWOn3Un7SWpvEqiJbOFp5GPLDB2gfjXRmkFVpwpyV05I4OG688LVr16bs405PX5EZ+BPjZ9kv/CcMs6jbw0m3b6Vd/wCFM+OVfzh47mebbtEbs/lflXt+DS81X9lYbs//AAKX+ZnLiXHy35f/AACP+R4RD8D/ABv5brN4vjHmZ3+W0vHuKm0r4E+KrXY114ymmdG/hkfBX3z3r3Kij+ysLvZ/e/8AMJcS5hJNXir/ANyP+RleH9KudJ02CC6uje3EahWuG4L/AFFaMikxsO5FSU1+VIzjivVjFU0lHofMym5ycpbs8L+FOlz6X8V/GKM8Lxm4z8o2tk4bkd/vGvc93NeL308Hhn4+WrujQJq1sUBH3ZZRj9dqivZVc7vYnivLy9Kn7Sj/ACyf46n0WfSlWqUsQ/tQj+Ct+hNRRSHivWPmRaKb5g54qlq2tWeiabcX99KLe0gUvLI5ACADOTSbS1ZUYubSirtl0+1cV8YGjT4b6+ZIPtCC2bdHn9a6fSdZtNesIb6xmE9tMNySL0I9a5j4uQvdfDjXVj3KTbFj644J/QVy4h3w82tdH+R6WXwcMfSU1ZqUb/ejjP2YIbiD4dwrdCNZWuZHxEcjBwQPyNez7sNXg37MFxIPC09sxJWO5O0bT3A/XiveF5J+tcuVP/YaT8j1OJouObV79ZMkpsn+rb6U6mS/6tvpXqnzC3Pm/wDag0+4udS0C5gA2xkhizYPLKOB3xjP0r33w6Suj2gbkmNefwFfP/7R2rmLxh4WgkiWSNdzoD180MFGfbBr6B0Fn/sq0EihX8tQwHY4FeBhf+RjiPPlPuc15lk2CjL+/wDmatIehpaQ9DXvnwpHJ8yPXz18T72Bfjn4WDW+MNHHJNKgaM7icKM9CTj8xX0Mw+VhXzV8btSk0r4ueF5JFMlsZISYVAO5hLwQPXnr7CvFzb3cMn/eX5n2fCsPaY2cVu4T/wDST6TjG3Hpnj34qTHaq9rJviQ4wM9PwqxmvYWyPjZJpu4hHykd64L40afPqPw/1CK2uRbSoofzCoPAPT8a70nGa5D4rWst18P9eEIBlW0aRMnHzLz/AErnxKTozv2PSyyXJjaMv7y/NHy1+zx5q/Fe2Vhk+WzMSDxgYwK+1K+M/wBm24a7+JEU0r7nkgLdcjPfHtya+zB1zXiZDZ4ZvzZ9xx83/akU+kF+o+iiivpT80CiiigApKWkoAax+U15D+01pc2q/DWVIAzOlxFLtTrwf/r1683Q15d+0TIU+F99tk8pi0Y3e24cVw41J4aontY97IpOOZ4dx/mR8rzeGtRh8Lx3V1cwx2akoI1ly0bE4Ax6mvqj9n2y+w/DPRYm35WMtl++STn9a8Yn8F6XqHgXT7iG1W/1KFMuEkyWTb82T6fhmvcfgfdSXXw90qSWzNmPJGIGOSo7Zr5rJ6Xs8Um+sf8AI/S+K8c8VlriulTXRLvbq2/U9CYLJzhsdOhqJrdHz+7BI6cV458QPiP490HxJNDpvhYzaZGVEcxHmtcZ6/dPyAVnSfFP4iWtoDL4W855AWRkjbC+ikete7PNKNOcqcoy0/uux8FQyDF1aUKsJwtLb31c9yS3gjXaIlX6AChbGJWyI0BPXAFfO8HxY+J8qyxz+HXDlSY2jtXUA9gcnmuz+EvjDx7rmoXMHiXREs7JCPLvB+73k9gmSfzxU0s1o1pqEYy1/us0xWQYvCUpVp1Iadppt+h6v9njVSPLUdulJBHC2dqJwcdKzPHOoXGleENYvLT/AI+IbWSRDjOCFJrxv9mTxJqOtQ6ul5e3F4i3CmM3LFjyOSM9Bnp9K6qmMjSxFPDtO8r6+h5+Gy2ricBWxylaNNpW9T6A27ckAV578cvElxofw41U2Z/0q6jFtCB1Jfjj3xmvQWJ5H41454rivfGHxk0rSGsZl0rSVF3JM3+qdz90fUEfrU42TjQcestPv6/IzyenCpilUqfDTXM/SOv4vQ3/AILeCP8AhD/CFlFLHGt1IPMnK/32GT1x2wK9GCj0FNWEoAFwABUm0100KMcPSjSjtFWODG4upjq88RU3k2xNp7UhjOOTkVJSHpWtuxx7Gdq+mx6rpd3YygeTcRNE3OOCMH9DXi/wJ1i+0DWtT8IakpgNjIWtoyekOcAe9e7NyDjg4rw74weG/EGm+MdA8TeHYJbl1cW9xbxAHKlgQTmvKx0XT5cVTV3B6runuv1PqMlqQrU62X1mkqium9lJbP57HuJPzEY7V47psdv/AMNC6tON32j7BCh+fgj3H416zbyPLaxtMu2Qgbl9CVrwH4mapJ8M/jNpfiaaMy6bqEawTeSmWXGB+J9OaMxqclONTpGSb9B5FRdarWw8filCSXm9Hb52PouivLpP2kvAkbSKdSkLxnDosRYoc4wcHjrVqP8AaA8HTNN5N5cTpEMvJHbsUHHTPrXT9ewn/P2P3o895JmcdXh5/wDgLPR6K89k+PPg2CziupdT8uKRN67l547Yz1rNk/aU8Ex9bm6YnBXbBndkZ45pSx+EjvVj96HHJMzn8OHm/wDt1nqlI33TXKeDPihoHjxZf7JuGkeI4kjkXayH3Ga6pj8px1rqp1IVY89N3XkeZXw9XC1HSrxcZLo9Dyz44+F9Q1Tw7b6rpCKNZ0iYXcDgnIx98Djnium+Hvi+38VeHbS8ViZ2UCVeMq/Qgjsa6eSAshXg545ryO++H+veC/FEmreFDE9hdS+Zd2EjkDJ6svHFefWjPD1vrME5J2TS/M97C1KOOwn1OvJRlFtwb284vt3XmexbhSO+1SfQZ6V5Pp37Q2gTQXpubTUoZrSYW8iC1Lb5M4wnPTPc4FWj+0R4LKzj7ZcJJDuDq0JyCBnHXrWscwwrSbqJert+Zzf2HmV7KhJ+iv8AkelO67TuBx3rx74262fF0UHgPSZQ19qjxrdNs3LDblhuYnp9OtY+ofG7V/iJZz6b4C0i4W8ZWH268wIoQB/sk/Me3J+ldX8JPhjd+FYP7R1eUXGtXQzMd5ZY+c7VyOlcdTEfXmsPh1eL+KXS3Zd7+R61HL1k8Xise0qkfhhfW/Rvslv5neeGvDsfhvR7TT4SDHBGsYxxwBVjXNMj1bR72ymH7m4iaJ9pwdpGK0KSQbo2HtXsRpwjFQSslp8j5N1pyq+2k/eve/mfPfwXktvB3jbW/DWWXy5A8XmHmRsfNtyfSvoDdyOMema8P+M3wz1OPWrfxn4eO2/sSHmhUndIF5DDjnjqO9WfCf7TXhq+09P7ZNxpepxxBpbeaPBPOMjnrntXhYavHAylhK7UVq4vo129T7fMsFVzqEMywSdRtJTS1altt2fc9spsjfI2OuK4Wz+N3hC/tfPh1RTHkDJXHWuF8UftJWl00+m+EtNu9a1J/wB3DJEq+VuPGc5zwfavRqY/DUYqUpr5angYfIsxrzcFRatvdWS9bmZ8RvDNz40+N2g2lvgraQia7yQQsW4H6gnGBxX0FAojUKB7/wBK83+FPw9vNF83XNauDeeI79V+03LcEIDkRgegr0tVw2R+PNZ4Km7zxMlZ1He3ZdDbOsWqjpYSnLmhSVrrq+vyvt5IlpKM8Zxmo5LhIkZmOFAyT2FeofNb6Id1z9K+b/i9bx6h8cPCtjLIIopUWTzCuSpEmQAewP617fJ4+8Pq0qHVbTfHncvnpkfXmvnX4reMvDusfEjR7qATPLZyqGuUcFHQMCCMH1rwM2qU/qyTkt118z73hfCYlYyT5JL3Ja22utNz6lhj2KB0Hb86n6VxWjfFXwvqAaNNYtRKgG5XlCkfma6fTtcsdYUvZXMVyv8AejcMP0NevTrUqqThJP0aZ8dXweIoN+1g16povN905rkfilfTab8Pdfnt44pZktHwk7bUORggmuurkfil9mj8A62bq1+3Qi2b/Ru8jHoPzp1/4UvRl4C31qkmr+8vzR8yfAKaBfiNo3kpJl4HDqRtEWFzgD0yPWvsha+N/gokC/FbTgXWC4CuojjQjfhT8pOeor7IXrXgZGn7Gd+/6I+547/5GFNrrBfmx9FFFfTH5uFFFFABSUtJQA1u9eW/tDW/2n4bXKsGKiaEvs67Q4yfyr1Ju9ec/Hi3+1fDe/haVoVcqCw69elcON/3ep6HtZK7ZjQf95fmfN83iex8Cwzf2EzXcU8W2MTHdgMuHJ54xzXvv7O+U+HNnGJJG8l3j3yNuJAPHJ9jXznq3h+CytbMw/Lcx26mRcDB56nivpf4Esf+EFtvlOdxzxjn1r5bKedY5Rei5Xp06H6pxXGl/ZilDVuSu3u7J2PSGVdvIx/nrSYGD8mD2968V8aePvH1r42vdJ0zw+0djBH50F4BvW4GOR7H2/WsHWPjp4w03Qr5rzQv7L1CKTZEsg3+YMZLAZ/QV71TNqFKUoyUtPJ2Z8Bh+HMZiIwlSlF81tOZXV+6PodQpT5lXoOcU+MdgAOeqivmHTPi58UNa8Ozy2WkJPcQgM03kFQ6552gnnivQfhH4m+IWtagw8TaRHZ2AjXbIw2uzZ9Bnj60qObUq81CEJ69bafmVjOHMTg6U6lWrD3enMr/ACR6T4wtnu/CurwR43yWkiLzjnaa+f8A9lm3mju9UDu+1FhVFk+8ByTkD3Jr6A8ZSMnhXWCjSRv9klIePhl+Q8g+teD/ALKshmXV5Si5aSMvLGeJDg8n3+lZYq39pYfvqduUOUchx3a8PzPpLb7CoRbiNgyqMj35xU+6qOuaomj6LfX8gJjtoXlYDqQoJP8AKvelJRTbZ8LCMpSUY7vQueYPQ07NeE/CP47XfjDWJbTV7cQJM5+yzR/KhGeIzn+PHavcVk3YI55xXJhcVTxdP2lLa9j0cxy3EZXW9hiY2e5NSGlpK7DyhpUdKYxBPTg4pzcZPoK8l134r39t8X9L8L2kSGzb/j7ZxyCRldtctfEQw0VKfVpfeehg8FWx0pRor4U5P0R615frzWdrfh2y1+0a3vbeO4j7BhyPcGtTdUckyxws7ZVVGSfQV0SUZK0tUcdOc6clKm7M84k+Avg92Vn0hCVYt95uSfXB5/GtnS/hr4e0OwaxtNNhhtmbeyKOp9Tz1rk/FnxyEd1caV4Z0i81rU4yVZki/dKfrnk+1cjdXnxk162QR2cdkkjb96OsUij+6RzXgyxGCpSfsaPM1p7sP1sfdQwmbYmmni8T7OL2U52+dj0+b4SeErm4aRtGtXYk5yvGSKX/AIUz4SjtVtU0S2FuG3hcEEH65zXnpuvi54btUvpoLTVoYnAe1i+Wbb3YnGDj2rrfA/x10fxTfDTLuK40nVwQPs14gQucZO3J5q6dfBTmozpckn/NFK/zMsRh82p03Vw+IdWEd3CbdvVb/M63wz4A0fwjLcPpljDatO2+QoOWPua6Pae9NEytyOecU7dnivajCFNWgkl5HxlatUxE+etJtvuIzDaeM1VvL2C0hLTyrEmcZkOM1aK8GuD+JXwrX4hLZsb+SzktS2FUkxuCOjL/AFqKsqkIXpx5n2vY1wlOjVrRjiJ8kertc1tc0vRdYsZILtYgkx3bg205HPBFcJqXg34aWk39o3TWMbKylnacBSc4GRnk5rj9a/Zj1lY2v08UtLcQM0scZUqo4wVGPavLvAHwr1P4gX93axqsRt2B8683GMHPKgfrXzWIxVXnjTqYRXk9L2ev3H6hl2W4N0J1qOZNQhbmsmrX9WfV/hzV/CtrGIdJuNPiTI/dwsg5PToec11ytlQR0zwV71876X+yhf28xkm8RiNmI3tbKwJHcD/GvoPTdP8A7PsIbffu8tVTcTnOBjNezg6mImrV6KgvJpr7j4nOaGApzjLB4l1W97pr8WW/MHPtUU11HGuWOPrT2XcpGK8o+NXgHxP40Wy/sPUhb20OTLaLI0RlbIIJcDOB6V1V6sqNN1Iwcn2R5OBw9PFV40q1RQT6vZHprXULowLA9/mNcN4w+E/hTxpHi/sYVmU4E1udjj05HvXkUnwF8eC6tzZaw1okYBxJeOwLep4prfAr4lQ+beN4jjEsQYgR3UuXGPTb1rxamMq1o8lXCNr+vI+6wuV4TCTVTD5nGMvK6f4M660/Zx8O2d1/pGp3Fxakr/oryhQdvTkDPWvTPD/hbQPDsaLp1nbQbeN0aAMfq3evkGBPEuoeJbbw/FqV1LqUwAw07YRs8nOeMfSvRNJ+AvxFsL5Xg1yK0D8vK13Iz5/75Irz8LioQbeHwnzT1/GJ7WaZZUcVHH5kldXSaaTXfT87H0wb6GOQIWxjtn9asrIr42nI9q+ar39n3x/c30l2fEdq8xXG9rifcwHI7YBz7V7D8L/B+seENAjtdY1Z9Vuc5LsSQv8AsjgZFe9QxdatV5J0XFd20z4PMMswOFoKpQxcakuyTO2bBUj2rnfHHhceMPDN9pBuprIXSbBcQMVZMHIPat+SQJGzYJCjtXzt4o+MPi/xVr19o3hCx8sQZP2hkD7lBxkZ6Z7VpjMTSw8LVU3zaWW7ObJ8vxOOq8+HajyWbk3ZLsxNN/ZVaOO5t7zxLNcQS5wI028E9/WrFv8AsmafG0hfWrqV+dvACqCOmKwNM1P4uQ30kpsbx9pHmLMQyPj+6P4PoBzWheeIPjHtYRWZ3Kcr+5Urg+pr5qP1CK/3Sf3S/wAz9MqVM857RzCnr5xX5I0rX9lPS1uM3GqSyx4ZZFCgbyRwc9seg616H8LvhrafC7STYQXUt5I8hlkmlIBdieuOg47V5HpOo/GRPE1vJdQSPazRHMZjQRpjkZOMgn2pmn/8LluNavZmSa2VZWaJZNpgZccDHWuilVwuHmqtLCzv6P8AVs87G4fMsbCVHFZhTlGyfxK34I+nd4yOD+Vcl8VLyKz8B6vJNP8AZ08nb5p/hJIwf1rR8IjWToNoddNv/aWwed9nzsz7A1g/Gd41+GusmSLzU8oEg9uV5r369Tmw05rTTr6H57gqPLmFKne9ppabb9D51+BNuLL4pwQFhNKQ00twSHDk9Cv90npxX2KOvTvXyB8C7VLb4qWcWlTRf2cIDIw8vD8joTznmvr9c+1eVkdvYT9T6/jl82YQf9xeu73XT0H0UUV9GfnIUUUUAFJS0lADG+6RXmn7QUcknw3vvKOx0eNhJn7vzDmvS2HWvOPj7IYvhvqRBUMxQKX6Z3DtXFjP93qeh7OTX/tCh/iX5ni0ugyXnhGzllkjk2ruRScM/qDXtnwX1CS78D2TvD5boDGRj0NeDaH4gj16NUtIoY5bUbWh1CUxxlm44Pb8BX0F8L3MPhn7O8Sx3Fs7RyrHyqsPQ9xXz2WcssRGcX9lo/QeJVOGEdKqtea/pe//AADtJNoUMcAhecf0rxD9p64Nh4bsJkhUsZyd+wlk+XrntUNv8RtYvfjh/Z5vfI0mF2tFs9oCykD72e5HtWt+05r2maf4HSxv1naS9kxbrCucsvJyc8CvQxWKhisFXUHbluvuPCyvAV8uzXCKa5nOzsuz/wAjv/AdvLH4R0rzNpka2i3dxnYM9q09U16w0K0kub65is4UXczyMF6Dt61ynwh8RPr3w60m6faH8gD5TkHHH9K8s0Oz/wCFq/GDVIvEDyXVppLNFbWucQD5h1XPJx3NavFeyw9HkV3NJK+i26nFHK/rGKxLxMuWNJtytvvay+Z0/ij9o7w5d6PqUGkxXWoXAjIOY8Rqp4DEjPH4V5b8F/itb+CNPuJbnT5Ht3uN9w1nFkRKTgFjnrz0r6C1b4W+HIrGWWLSYIzCvmbYUCltvIXp614d+z3Z6T4q8UeIraa3lMDSLcJbu2Y9rZGGHfpkV5WJhi44uj7SouZ3tZOx9fls8olleK9jSk4R5XK7V97f8E9u8C/HDw38Qr6ay017hLqP/lncRhSR/eGGPFdB46v7ew8G6zcXUbywR2shdEGSy7TkYpPD/gPR/DDs2m6fb2eepjXk/jTfiBB9o8F63G2SrWknCnB6GvfhGvGg41mnLXbb8T89m8FPHw+pxlGneO7u9+6Pl7wv8NfEPjjwvLr2j3cNlGJfPtbYMVl3L1O7aeSOOgz6ivePg/8AEVfFmjR210+dXtVVLpcZG76nv+Fcp+yz/wAiDMiHbGLt1RXcsV4U4JpfiN4bm+GfiSLx1pIl+yllXU7KE/K65HzhfUDPpXgYSm8PRp4+F7Ne+u/mvT8j7zOK8cxxlfK69lKLfs3tr/K/Xv3Pdt3saWsHwr4ssfF2k2+o2Ds8E6hh6j1BHatzd0GDX1cJxqRU4u6Z+V1aU6M3TqKzW4jfdY+1fPmq6lHa/tJWULQAecqrnALE+Xw30r6Df/VtXzt4stJB+0jociYkLKmVXgooXqfWvJzS6pQkv54/mfV8NKMqmIUv+fU/yPopiVyeteXfHfxpd+GPC6RWKRyXN9J5OyV9gKY+YA+uM16iQT0FeSftDeE49e8GfbSpMunuJ14yMH5W4+h6105g5rC1HT3seXkaoSzCisR8N/8AhvxLvwU8MPpfhKzurm2jivbxRPKqgcE++OeK9LKE8cAe1cP8H/FEPiLwXprxOjGKIRPsPG5cDiu6WQE+n1qsHyLD0+TayJzeVaWOqusveu/zGtGdrDjJ9a8f+P3g0X3g+XWbK1I1jTmS4imgHzqARuPTOMZ4r2TmmvCJFZWVWUjBzzkVriaEcVRlRns/6uc2AxtTAYiNeHR/f3XzOM+FHiK88T+CdKvr2FobmWEGRWGORx39a7Wo4bdYIwkaKijoFHFS4NXRg6dOMJO7StfuYYqrCtXnUpx5U22l28haSlpG6VscpBdL/o8gH90ivCfgHeXd54o8VNMqmIXm1ZAcA4ZxgDt0Fe7XjiO1lY9Ap6c14Z8D5DP408TSrMrRSTK6xIBhRzz9c5rycW19Zwy83+R9blP/ACLcbp0j/wClHvdJS0V6x8kJimlCeuD+FPooAZsPrUV0p+zyd/lNWKgvn8uzmbBOFJwvU0Jalx+JHy14Shks/jdLeeUkltdahJFG3Unoc57YPavqgKa+OPA/ia6X4vWO+7ku45tRMf2TauY8ggtken0/GvsgMOOK+dyeSlGrb+Zn3/GVKdKvh1P+RC7aNtOpK+iPz0zdeZo9FvishibyX2uoztO04OK8F/Zhs4Zm1W/a4ea9mkG/e33VGcADtX0FqGPsU5bG3Yc56V4d+zbpC2r67dyxPBeTXjF0IwoXJ2Y9iK8bFRbxuHkv735H2OV1VHKMbHZvk/N6eh7v5beoo8thjBGBUtFexZHyF2ReUfWjyz/skfSpaKAuyMx8e1eb/H5buX4Va5HaRSSSNGoKoOcbhn8hk16UwypFct8TJza+ANfmKeZtspSVyem01zYpc1Cae1mejlk3TxtGSV7Sj+aPlf8AZ03Q/FGyQiTH2dkDEjBAH+NfaAPNfG/7OIuLX4lrDIY9r2zMd33/AL3y/pX2PXh5Df6tJ+Z9vx875pH/AAL9SSiiivpj81CiiigApKWigBjdDXln7Q6xH4b3P2j/AFAljL4znG4V6m33Wry39oyGST4X35jO3Y6OTjOAGGTXBjrrDVLfys93I/8AkZUP8S/M8m8D2ukWfgSO91GBNaubgFLW2gjBkXsA5zk498YFemfs+6ld6j4RvjeTxzSrfToNjA7VDcA4/iHpXzj4L1TXdRuLPSLKRrUNKJDdFQoyOh9q+mvgtbwW/h+6zJbNevO5umtI9itJ0Jx6185lkuerTUVZJP0bsfpnFOHeHw9VVHzOUk15K7tpsl+Le541azaen7RpSYyPE2pM0AVt2JSvJA/hG7FegftO6bcXGk6LcwxSTQwzssnlkfICoGcHrXm0/wBnt/2g0CwFZW1Ty1KAghmIbd6Yr179pBYofAqXTSSq8cwWNI+js4wN3sOtZwTqYXFxt1b0DGS9nmmWTjfWCX5r9TS+DMNnp3wpsfsskz2y27MJDgvjJJxXnnwDuVvvif4huYDcR2rLgQ3GN2d+dzehNek/C+WKf4XW5SPyIfszDbGccYOcGvKv2cJbpviF4jS5LGVQFk3jDE7+Cfwrtno8DFar/gHk0481LNpvfz85H0rqzLFpl3I/3ViYn6YNfNv7LnlzeI/EFxFCIfNk3yBeRku2F9sCvpLWFLaTeBRljEwAPfg18/8A7Ms6/wBqa/F5HlTLOpfjBOS1duM/33Der/I8XJ5WybH2/ufmfRtYXjRHm8IawsbBJDZyBWboDtODW7XN/EJ5o/BGttAcSi0k2k9Adpr1q1vZyv2Z8jg9cRTS/mX5nmP7Lqq3gV5WeN55bt2k8vgBgAvQ/SvZr6xj1Czmt541likXY6sMhq8P/ZUuJp/Ct95qFIxeF489SCqnk9znNe9MMqQRnNeblNngafa36n0PE96ecV3fVSPCNDuk+CvjqLQriSV9D1QmW2uJiMRNu5TJ7c17lHMsqq6/MrAYxXOePPAOn+PtFlsdRhVz96J+8b44I+lcV8H/ABdPYXk/gvWnkk1jTFAEj4xPHn5XH8vwoo/7FW9g1anLWPk+sf1QYpRzbD/XIfxofGu66S/R/eeuSZ8tsV86+I4Sv7SmntGWWSRIi2O6Ba+iXbKsOa+evGl4tr+0Lo+1fNcJDkKeUUnBz/OpzWzoR/xx/M14ZT9tXS/59z/I+icHsarX1ml5ZzQTKrxSKVKkcEYqwrBsUN8ykdK9l2asz5BNxd1ueLaH4L8TfCOO/bSfJ1nRADJDZAlZkYklgML83tzUukftL6FJO1rrFlfaLeR/6xJ4wRj165/SvYTESO2feud174faL4m51DT7eZ8cPtww/Ec15EsJWopLCVOVL7LV1/mj6inmWDxknLNKXNJ/ai7P5rZkug/EDQfE0YfTNQiuv9lGG78s5reWZXx1H1rxjWP2a9Ot7iTUvDt/c6VqaqdjJLtUnsDgZ/PNR+F/HniTwLNHYeN7XdatIsVvqlv8yNkcbv8AE044ytRfLi4cv95O6+fVFVsrwmJi6mWVee32ZaS+XR/L7j2+iq1rfRXkKSxEtG67gfap93Tg1610fKNOLsx1JS0lMRU1JvJsLh/7qFv0r57/AGb5LP8A4SbxIturBvMXOef4m/xr6HvFEltKpGQVII9a8K+AFrFaeIvEcKIvy3PDDr16V42MT+t4aXm/yPscnlFZVjl1tH/0o9+ooor2T44KKKKACobxd9rKvqpqamTf6pvpTW5UdGj448IeH5NN+PVvbGTzXt753DMONpPTp6V9j7TuzXzTpMc037Qk67PIVJt0isMjP8OCfXrxX0sD6V89lEFFVUv5mfecX15YirhZS39mh9JS0lfQHwJXvP8Aj2l9Npr5n8A/GHTvAHibWdP1uWVLeS8cxOo37GzymB2Ar6auAfIfHXFfJ3hH4aJ8UPHmutd5sbG1uijJC2GmGTjnHyjjt1rwsydZVKH1f4rv021PvuGaeDqYbFrH39nZXa330se82fx08G6hKkVvqnnSv0jRCW/EVBqHx+8Haa0QlvpD5hIG2PI46554rDh/Zf8ACUc0UpS5d423Am4IP5gCrlx+zn4WubxZ3hkdVHELSnZn1A9aXNmrj8ME/VmPs+GVP46rXoi9/wANB+CVhmkfU2jERAZXjIJJ6AetFr+0F4Ku9QtrNNSYSXBCozJhSScAZzVC4/Zt8I3TKZLaZtowAZ2Ix9M1b039n/wnpepwX0VgrzQj5RISyj3x6+9VH+1bq/J+JMo8Ncj5XV5rO3w79D0hZ1kXI5Fc58Q9QttM8Da1c3kck1tHaP5iRLuZhgjAHrXQrD5eMYA9AMcVzXxLbb4C1870jP2OT95IMqOD1HpXq1r+xk+tmfL4NKWKpLpzL8z5j+AstrJ8U7b7KgSLy3VTIfnzgkj3FfYi9a+Kf2csL8UbONVhX9w+/byBzwFHb1zmvtcda8HIv4EvX9D7zj2PJmcF/cX5sdRRRX0p+ahRRRQAUUUh6UANb7przD9orzD8L9RETMr74wSBnjeM/pXpzc5rzX9oSxfUPhXqyI2xlCOPfDDg1w4xP6tU9Ge1krSzHDt/zx/NHzP4Rt74a8lxDeQadptunnXE8zZLrjGFBGMmvf8A9n2z0+HwldX2m3l1epd3UssjXXBDZ5AHYCvmOSZbTTbRDcqsTZ3QDnZ7c9q+jf2cZp4/BNx5/mkyTtOjSY5VgDgAdMYr5HKJKWKhC3R/efsfFtGX1CVW/WKtbdJvfu7+eh5zG15rXx5WKVlihg1jzFXIBcKByD9a7r9rHVZ7XwxpNrEpEc1yRLJ6AL0x75rzHwvdz6h8f4rueRVxqbgQ45BIwfw716Z+1hk+H9E2wmWX7WSGHQDaQc+3I/KtYT5sFi5J63/U5cRT9nneW05LRQX6m/8AAO4kl+Edp6RxOqll7D2rzL9n3VNSb4lXbzssyXwk81zgvvV+nHYV7B8C5o7n4c2IWMIFQodvQkHkivM9Ds0+H/xu1C5jijt9CDeXMxUKId53KFz23dTXVVi40MHVT0i1+KPHo1I1K+a4fl96V2vk3p63asfSGruV0u8KcOImI+uDXzx+zLfT3uv68bmdJpt6lTt2ts3NgkenpXr3in4neG9J0WeabVICJIyqCOVSWJBxjnmvnn9nPxlpemeONVE8n2aO9XMTTMo+65wmc9gc11Y2tT+uYa0k7N9fI8vJsBXeTY9um9VG2nZ6n14ehrD8bL/xR+t5KgfY5clug+Q9avw61Z3DIsc6OzcBVYGqPjRg3g/Wxj/lzm/9ANe9V/hy9GfCYeMoYimpK2q/M8f/AGU4hD4TvU8zL/bZPlLZ2jC4GO3Svejnt1r5+/Zda3j0m/WANzIhLZ++23Bb8xX0AOOvWvMyh/7DT8r/AJn0PFS/4V67fV/oJtPO7GK84+JXhSW1jPirRrVH8Qacm5TnBkiHLRnHXIHHua9K7c1HJHuU5xyMGvSq0o1oOnLZ/wBX9T57C4mWFqqpH5ruuqfqcz4P8baf400e2vLSYOJB88feNsYZSM8EHI/CvC/H1u2oftCaUEujbiCa18yKRflckAgL69evsa2vF2lv8FfGsXii280+H9Sn23tvECRG7kfOB9f5muYm8aaD47+Pfh2/tBMr27/Z2WcAEyDOMLk+uc+1fNYuu6tKOGr6TjOPzV90fpeUYBYetVxmDTlRlTnrb4Xb4X5ra/oz6njyFXil8wADg9aRj1HfFcN8XPFWreD/AAvLqmlxLKbdlebIyfLz82B9K+lq1I0IOctkfmOHoSxVaNGG8tjvN49DS59q53wj4ot/FOh2moQPvSZA4x645re3Dgcg+lXCaqRU46p6kVqU6E3TmrNaD2BwcVz3jTwrb+J/D15YzqCHjO1hwQwHykfQ10WfaqepX0drp9xM+QiRs5OOwHNE4xlFxnsysPOdOrGdPdM8j+APi661CxudJvHaeewlaLzOp2hiAD78V7NzXg/7OtvcX82s6v5Ihs7u43RYXAk5bLDPOOa94/i6V5mVyk8JC/nb0voe/wASQp08xqKmrbXt3a1/EfSN0oprSDnAJr1j5ghuOLeUnpivDPgTNJD4v8S2zrIczeYGYgrgkj+le5XTE2smODtJrwP9na4R/E3iKIiJZY5iOFIdxuPzEnqOe1eRi9cTh7d3+R9dlMf+EzHO3SP5n0NRTBIDz2pd1evvsfIjqKKKACo7hisLkdQKkpk3MbD2pjW586+F78XXxwvI9TZfMS4k+zxxkkZBABPA6CvoleQM9a+WrC3kg/aN8uLgi6eV23dUZf8AGvqYV4GVSuqq/vM+14ppqNTDSi9HTjoPoopK94+JIbohYJCeAFOa+c/2dryU+O/FEErZzJ5gXr/Gec/jX0ZcgSW7rjOQQa+a/wBneGOz+I3ieNFWKNCVWMn5h85yee2a8XG3+tYb/E/yPtsk5ZZXmCf8sf8A0o+m6Kga8jXqaPtkfr/Kvbs+x8Xyy7E9JUX2pB9PwpPtkfr/ACosHK+xKW+X8K5H4qwxTfDnxGk7bIjZShif9011YmDDIBI7VwXx0nlh+E3iV4hz9kIOR2J5478ZrmxP8Gfo/wAj0cti5Y6hHvKP5o+UvgDHcL8UNCkjPy7j5nGDgqetfdigivgr4CXEEfxM8OtNO8Z83y4BkkPlcEMe5r72HU189kH8CSXf9D9E8RU1mNK/8n6sdRRRX1J+UBRRRQAUh6UtJQAz1rzb9oG4a3+FuqMCRlUB2nB+8Cf0FelY615x8etLm1b4a6nBBG8jYViqddoPP6VyYxv6vO3Y9nJnFZhQ59ueP5nw7NMXm3HcocA7jX0x+ytqf9oaHq8BnLOtwCImbJjQqAv5kNXzNeK6yRTyMTtXCFuAV6f/AFq9F+APjq18FeLHnvL14dPnXy5GcAKOcgn6f1NfnuWVlh8XTnJ6X/M/pXiXAyx2U1IUleSs18nseseBfgjrmk/GTUdc1CKH+zklkmhm8zJkZzxgY7D1r0T43fDy88feFPK051TUbVvOgVnKq7D+FsA8HpXUWvjrQLqGOeLU7UxyLuRvNQZHrnNaMet2U1v5yzqYSN28MMYr7ingaCpVKUdVO99V1P5+xWbZnUxdLGVI2nTSS07f1qcz8MfDV34S8Fadpt6EN7HGFkaLkBj19OK88+JnwY8QeIPFKXukXFu9nfPGLqG4dlEQX+JcA5r16Pxdo9xNJbxX9vJMn3o0kUkfUZzV8albyAMJFI747VtLBUq1GNB6xVvwOejmeOweLnjIxtOV27rTXX/hj5pvv2V/EnnrHbarpf2PBLM/meZk9gdpAFT2f7It4sE/2jWbV55TwVRgI/UjjrX0Y2u2McgjadVcjhWOD+VTNqVsigl8DtxXIsnwd78r+9/5nsy4vzzlUVK3/bq1PFPAn7Nt74U8QWmqz+I5pGhlEkkMDsEmx0DZ7fSvZde03+1NEvrLcQLiB4iQcdQR/Wp21S2WMu0gVRySeKjTWLS4jJWVWXHJyMV3YfA0cLB06UbJ/wBdT53G5ljsyrRxGJd5R20S/I8T/Z08Kaj4WGp2d4ZFSOYbY5I9pUc9+9e77ux5qgNQs13SeZGuOWO7+f4U2PxJpszhY7qJ29FYE/zowuH+qUVRvtf8ycyxNfNMTLFThZvc1aRvunvVVtUtl6yqD9RTF1qzf7s6N64YHH612Hk+zn2INc0WDXNMmsrqJZYZFIO76cEe9fKuh/BvV/DHxs0+GPzJbO2uUuILpwTugHVS2OCP1FfV7a1ZbQTcIM9MsBVRvEWlROM3cCkccuK8/FYGninBz0cXv+h9PlObY3K6dWlRjeNRNNW79TY2nvWd4g0ddc0O+0+XBW5gaEk+4xmhvE2mK2DeQg/74/xqb+2bNlOLhPruFd7SkrPY+djCtSkpqLTW2h80aDf+K/gXJLa6nbi50WNdyuWOw5b+FsfLx2PFeq+Gvj54X163dnmmsZI13SLcoAF/4ECQa7i/XT9Rt2gulimjbqrgEVyF58LvBuoQ3MZ022UTDEjQjax+pFeJDBYrC+7h5pw7Su7fM+xrZhgM0XtMwoyjVe8odfkySX46+C1aOJdWWd5OFWNevOO+BXLat4u1b4uRy6DoFpf6JZy/Jd6rcR7Aqg4KxjnJIzzjFbMfwx8BabHDC1nZhIQCiyNyMd+TXTr4y8N6dhDq1jEqjhWnQYA/H0rT2eJrJwxU4qPaN7vyu+noc7+o4d8+AoznLo5dOzslr8/xNPw74cg8OaXbWVsqqkCBBj/9Va+01mW/ifTLqHzoruOSL/norAr+dRz+LtHhkET6hbrI3RTKufyzXqxUYRSWiWx8zOniK03KcW5PfQ1iflNeffEz4waZ8M5rGPUbS6kW6ziSJRsQDrk56+1dUfFeklW/4mFuMcf6xev51leJLrwxrlmbXVZbKeHOds7rge/Xisa/PKDVKSUu51YGjGNeLxVKUodUtGeO+Kv2p9PvdGuYdLtJhJcRskc0rqNmRjcQD2615N4H8fXPw71X+0/mvLiWIqIi+d6ZznI6HPSvo9PBvwys5Ff7LpCuF3hmZc49eTVi2X4dBSYf7KPygYUxscA+lfNVcHiqtRVKuIjdbeR+mYXM8rwdCeHw2CqOE/iv1+Zy9l+1Jp7SWZu9MngilTdNJ5iny8egzz+lezaBr1v4i0u1v7UN9nuEEiFxg4PSvM49U+Fd3dyhJdH+0RMBJtVAVPvxXaWfjrwxDbxx2+q2KxLhVVZkAAH416+ElWjJ+3rxkvLQ+NzXDYeaj9Twk6b63u0dbRWHJ420WFQX1G3UEZBMq4P61Uk+JXhqGHzX1e0EfZvOTn9a9J1acd5L70fNxweJl8NN/czp6juM+S+OuK5m4+KHhe1jDza1Zxo3RmmTH55ptx8UfC9vGhk1i0USLlczJgj86HWpR3kvvRosBi7q1KX3M+atB03W9e/aEkuUsLmEwal5lysgKrHGOBz3HcYr6+WvP1+L3glZZLr+2LMFSA8m4cegJqzefGjwdYtGsut24MnK7WDZHrx2rysHChhOd+2T5nfdH0+cyx+bTor6rKPJFRSSb2+R3VI3Q154f2gPAgx/xP7fnpjvViP44+CpkRo9bgkD/d2nOa7/AK3hnoqsf/Al/mfPvKMxWrw8/wDwF/5HbSoWjYZPI7dq+YfHnwd8Z+GPF95r/hKSSd7iR5j9ncIyBiSyFW4cemfyr2w/Gbwh5ZcazAVGejeg5xUsfxX8JXWnrerrVn9mOQrySKuSOoAJzXLioYbGRUZVEra3TV0evldTNconKdOg2paNSi2n5HytqE/xVuNcxerryTNgJGvyxqfUbOD+NW9HsfjOgCWMuqrE7n/j4A4bPXntX0De/HzwPaW8051VJ1hGXEK7mHtjuazf+Gm/AvkR3H2i6WFhlZTbjAycY4PBrwHgcHGXNLGP/wACX+Z92s2zSpTUaeVRtt8Dt91jyM6R8a5GVppb84yCY5lx9QMCsj/hF/i7ceVI0utqwY8C4xn8M4r6IsP2g/A+pSPHHrCo6gHbIu08+lSXfx88EWdqLiTW4ijKGGwZJBOMgfWtJYHBTV/rb/8AA0c6zrNqb5P7Mim+ns2WfhP/AMJV/wAInCfFSwrqAY/dJLFexYY4P0rmf2or4W/wlvozNJAbiWKJWQ4JJcHH5CrEv7TXgOMnbfyy8HDJFweOmSRzXzj8aPjPJ8UbyCGCCW20u1ctFG+MytyNx546jArpxWOw1HCOjCrzu1t02cWS5DmOMzaGKrYd0oKSk9LLvZJlL4N3DzfEbwraiNDtvvOk3cA4Xgj3FfequNxHU56V+fXwnguNW+JnhWDTztlhvFl3N0VAMtj8BX6Bx7hjd6ZP1qcg/hVPX9Do8RoqONoa68j0/wC3mTUUUV9SfkYUUUUAFJS0UAJj0qC6txcWskTAMGXacjORVikPINHqNNp3R8gfHv4Yt4fvkuYIkFncOVj2jCxnrg+nNeJyae8L/K0kLx8NggEfQciv0d1TR7bWLV7e7giuInGDHKu5T61wepfA3RtQeQqqwhuwUH+lfIYzJZ1KsqlBqz6H7NknHMcNh40MYm2uvc+G3gLKPMTdxtXJI478eh7jvV6y1PUIIXiW+uGs42/49lnJX6dePpX2G37OOhtht2JB/FioYP2adAtt3lLHHuYu21MbmPc15yyHEp30+8+klx3lU1aSf3HxxukSWSaNnhfPzSZCn8e9dDD4hvodHaKLUrxQ3JEM7bePXBH5V9Zxfs6+Gtqefaxzumdrv159fX+lLJ+zv4cYgpCsYH8KjiiOQ4iLurHPU45ymrZSg9PJHxl9r1LzRL/aMztKMebJIxJ9gSeK2xrXiCazQSzStCBt2sTlfc19Yx/s6+GhxJbpInZT0HrVj/hQuhByQpxjbyx6eh9acchxMb2a18yKnHGVTt+728kfIVx4g1eWzkhkv7qKOb7y7yoGOwx61Wh1bUbKGWOPULxTN8rBJW4Hr1r7IuvgRoN5AYpYUZe3tVOX9nXQJVZSDhjn5TjFEshxLd9H8yafG2U2s6bXyR8itq19tZWv7pUcYcGdsN7HNXtB1K3gu4p9QludihQqwyBW2k8819XQ/s6+HEUrJF5qEYKtzmrU37P3hSbaDYIgX+4SO3SnHIcQnze6KpxtlTTgoSs+yR8teJL6C1u5YNM1fUHim+dVuZdxXI+6cdvxrAt9Xv0hkCXtzCsnykRSMNyjnkGvsr/hRPhjbj7EuSMHntUMnwJ0SRixRSemcY47VpLI8RJ30+9mFHjTLKcFBwb9Uj5CTWLiSOCNZZvkOA0jnqap6laTRyLJOzEgllJf1/Gvsd/gJoLKo8oZXof69KqXX7POj3q7bh/NTsOhH44rKWQ4jsn9x00+N8sjK6TS9D5Fhv5nkO5pWdsdXY4A7jnrUst5dQzbYr26TzPvfvWP5c19dWv7Pmg20gcRq5VcLu7VE37O+iNcpKTkLn5frS/sHEWukvvK/wBdsrv8Lt6Hyk3ifV7a8SVtUuvO6+SZCAfwzVmHxRq379W1C4UT5ztdh27YNfVUv7P2gyXIn8pDIBgFhmnr8AfD6quYgWVtysOMVayPFLqjnlxllDS/dv7kfGt0l1JIWmmkmmbJBkOcD6nJH50iw20lrvS2KvF96Rhkc/XIr7Qm+Avh2TeVt1UsMHJyDVe3/Z/0OO0a2lQTRMMEHio/sHEJ2tE6Fx3l3L8LR8meG2ij2QvqE9pbzsN7I3BycYHpUd4yafqM01ndPJJ903GSWI9M5Ir6xt/2bfCsJUtbM+31c4+mKnuf2evDUsYijtxDDnJjU8H8abyHE8qVomb42yv2jl71nvorHyTCZoYZA8kg3tlxkkK3Y5zxTLqOe+tyzGSaNcmTzM+nueRX16n7PvhiMSbIJEZ+rCQ/4VTtf2dNBhkcTFrm2Y5NtIx8sn1I9fxo/sHEKyXL/XyBcbZZdys7+n9fmfJ0rT3kXlyv5gVQsW89Pp/hVS3trixRvLJjZxhSnVvXtX2fD8B/DNsAIbXylXoqtwPzFSL8EfDyyK/kEleg3dP0q/7BxF73RC46y+KtGDt6I+IpECohAXPPyHBOfy/nSn5FCu+UY7cKRj6Yr7Ovf2d/Cd25cWXlueSysQaLX9nnwrbOG+yb8HdhmyM+vSp/sDEPT3ber/8AkTq/19yzlvyyv6L/ADPkKZvtAgWYvujHAJOMe1NutDa3/fqqJDt4VuR7nmvsa8+AXhi9kLvalGxgeW5GP0pl18A/D91Zi2dHMYGOXycflT/sHEbaHPHjrAK1lJd9P+CfFVnZwSSDzITPEz7vJU557VbNtbST7FjdEI2BgOMDnFfYFv8As6eHLWZpYxIshG3cH4x9MVKv7PPhmOZZFgb5W3AbzjP5VP8AYNe1rL7zolx5lrd1zHxlLp8kMZjSMRo2MgKCG56kVWXTSFxIoLlQp3nJ689umO1fbzfAfw60hcxOGIx9/j+VMb9n3wq7F2s8yYxu3HNU8gxHeP3/AP2oo+IGAW8Zf18z4fks/JuPMVI12DavyY6+1LBvbZHBH5ZflfLGPr26V9qt+zf4UkuhcSW7vJt2nMhwR6YpJv2afB01qsH2JolVg6tHKykEHPBoeQ4prRr73/kb/wDEQMrsk4y+5f5nx+umNDA0fkkDk4VSCMjt6VhGEbpH8vKFjyONy+v+cV9v337N/hXULYwSxTBSMbkmZW/Olj/Zx8KJAIvsxwo2qQ3IX0zU/wBg4hqz5f6+RNPj/LYJtqTb8v8AgnxPbW7QsCjtGXAz8xGfwzUbQLbwsCwRN3TBwfTjPJr7dm/Zy8JzABrPdxj7xzUS/s0+D1jZDZswP95ycVf9hYro197/AMi14gZZu1L7l/mfE1pGfNTgIEGVC5+UepOKm/s99ysIwo27hxjHPQfzr7Lb9lvwW0LRCzdFYAHZMyk4OeTWvH8AvC67M2m7YMLljwMYqY5DiXu1/wCBP/IKniDlid4Rl9y/zPiC5sGOIww6k43ZAOPTHWo4tFmuGCZaUh9giQEu4I4AGOua+5JvgD4TkYt/ZsYcnJZWINaekfB/wzomqR6jaaVbxXqHImAO79a1jkOJb96at6v/ACOafiHgowfs6cm/lv8AeeZfs+/A+XwosWt6yI31WQ7olBJ8pCOAOOuOtfQIHJyO9IkW0YAUDOfl4p+K+twuGhhaSpQ2X4n4rmuaYjN8TLE4h6v7kuyFooorsPHCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAP/9k="

    dateUtils = DateUtils.instance

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new PdfService()
        }
        return this._instance;
    }

    /**
     * テストファイルの作成
     */
    public async generateTest(): Promise<FileData> {
        this.init()
        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: "テストファイル",
                author: this.COMPANY_NAME,
            },
            content: [
                /* タイトル */
                this.getTitle("テ　ス　ト"),
            ],
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        return new FileData({filename: "テストファイル.pdf", content: content}) 
    }

    /**
     * 見積書の作成
     */
    public async generateEstimate(dto: Estimate): Promise<FileData> {
        this.init()
        this.COMPANY_FLG = 1 /*NEW*/

        const detailHeader = [[
            {
                text: "No.",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査項目",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "単価",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査数",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "所要日数",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const detail = detailHeader.concat(
            dto.details.map((x, index) => {
                return [
                    {
                        text: (index + 1).toString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.inspectionInfo.inspectionShortName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.unitPrice.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.quantity.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: (x.priceInfo.unitPrice * x.priceInfo.quantity).toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.deliveryTerm,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    }
                ]
            })
        )

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: `見積書 ${dto.estimateNo}`,
                author: this.NEW_COMPANY_NAME,
            },
            content: [
                /* 角印 */
                dto.imprint ? this.getNewCompanyStamp((dto.agencyInfo.agencyName !== "") ? 17 : 0) : {},
                /* タイトル */
                this.getTitle("見　積　書"),
                /* 見積日付、番号 */
                this.getDocuementDateAndNumber("見積日", dto.estimateOn, "見積番号", dto.estimateNo),
                /* 宛先（顧客） */
                this.getTo(dto.customerInfo, dto.agencyInfo, null),
                /* スペース */
                this.getSpacer(),
                /* 件名 */
                this.getSubject(dto.subject),
                /* 条件、自社 */
                this.getConditionAndFrom(dto.expirationDate, dto.tradingCondition, dto.requiredAmount, !dto.imprint),
                /* スペース */
                this.getSpacer(),
                /* 作成・承認印 */
                this.getStamps(dto.authorUser.userName, dto.authorizerUser.userName),
                /* メッセージ */
                this.getLineMessage("下記の通りお見積り申し上げます。"),
                {
                    /* 明細 */
                    table: {
                        widths: [25, "*", 50, 50, 50, 80],
                        headerRows: 1,
                        body: detail,
                    },
                    layout: {
                        // eslint-disable-next-line
                        fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                            return (rowIndex % 2 === 0) ? "#CBF1FF" : null;
                        }
                    }
                },
                /* スペース */
                this.getSpacer(),
                /* 集計 */
                this.getPriceOnly(dto.amountText, dto.taxText, dto.totalAmountText, "見積金額"),
                /* 適用 */
                this.getLineMessage("適用：振込手数料はご負担ください。", "text-small-left", [false, false, false, true]),
                /* スペース */
                this.getSpacer(),
                /* 備考 */
                this.getLineMessage("備考", "text-small-left"),
                this.getNote(dto.note),
            ],
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        return new FileData({filename: `見積書_${dto.estimateNo}.pdf`, content: content}) 
    }

    /**
     * 請書の作成
     */
    public async generateConfirmation(dto: Confirmation): Promise<FileData> {
        this.init()
        this.COMPANY_FLG = 1 /*NEW*/
        const detailHeader = [[
            {
                text: "受付番号",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "試験品名称",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査項目",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "単価",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査数",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const detail = detailHeader.concat(
            dto.details.map((x, index) => {
                const same = index !== 0 && x.requestNo !== "" && dto.details[index - 1].requestNo === x.requestNo
                const border = same ? [true, false, true, true] : [true, true, true, true]
                return [
                    {
                        text: same ? "" : x.requestNo,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: same ? "" : x.specimenName,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: x.inspectionInfo.inspectionShortName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.unitPrice.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.quantity.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: (x.priceInfo.unitPrice * x.priceInfo.quantity).toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    }
                ]
            })
        )

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: `注文請書 ${dto.confirmationNo}`,
                author: this.NEW_COMPANY_NAME,
            },
            content: [
                /* 角印 */
                this.getNewCompanyStamp((dto.agencyInfo.agencyName !== "") ? 17 : 0),
                /* タイトル */
                this.getTitle("注　文　請　書"),
                /* 発行日付、番号 */
                this.getDocuementDateAndNumber("発行日", dto.confirmationOn, "請書番号", dto.confirmationNo),
                /* 宛先（顧客） */
                this.getTo(dto.customerInfo, dto.agencyInfo, null),
                /* スペース */
                this.getSpacer(),
                /* 件名 */
                this.getSubject(dto.subject),
                /* 自社 */
                this.getFrom(),
                /* スペース */
                this.getSpacer(),
                /* 作成・承認印 */
                this.getStamps(dto.authorUser.userName, dto.authorizerUser.userName),
                /* メッセージ */
                this.getLineMessage("下記の通りご注文をお受けいたしました。"),
                {
                    /* 明細 */
                    table: {
                        widths: [60, "*", 80, 50, 50, 50],
                        headerRows: 1,
                        body: detail,
                    },
                    layout: {
                        // eslint-disable-next-line
                        fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                            return (rowIndex % 2 === 0) ? "#FFF2D9" : null;
                        }
                    }
                },
                /* スペース */
                this.getSpacer(),
                /* 納品予定日＆集計 */
                this.getDeriveryOnAndPrice(dto.deliveryOn, dto.amountText, dto.taxText, dto.totalAmountText),
                /* スペース */
                this.getSpacer(),
                /* 適用 */
                this.getLineMessage("適用：振込手数料はご負担ください。", "text-small-left", [false, false, false, true]),
                /* スペース */
                this.getSpacer(),
                /* 備考 */
                this.getLineMessage("備考", "text-small-left"),
                this.getNote(dto.note),
            ],
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        return new FileData({filename: `注文請書_${dto.confirmationNo}.pdf`, content: content}) 
    }

    /**
     * 請求書の作成
     */
    public async generateInvoice(dto: Invoice): Promise<FileData> {
        this.init()
        this.COMPANY_FLG = 1 /*NEW*/
        const detailHeader = [[
            {
                text: "受付番号",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "試験品名称",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査項目",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "単価",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査数",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "報告日",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const detail = detailHeader.concat(
            dto.details.map((x, index) => {
                const same = index !== 0 && x.requestNo !== "" && dto.details[index - 1].requestNo === x.requestNo
                const border = same ? [true, false, true, true] : [true, true, true, true]

                return [
                    {
                        text: same ? "" : (x.requestNo === "" ? "※" : x.requestNo),
                        style: x.requestNo === "" ? "text-xsmall-center" : "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: same ? "" : x.specimenName,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: x.inspectionInfo.inspectionShortName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.unitPrice.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.quantity.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: (x.priceInfo.unitPrice * x.priceInfo.quantity).toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: this.dateUtils.toJapanFormat(x.reportOn),
                        style: "text-xsmall-center",
                        border: [true, true, true, true],
                    }
                ]
            })
        )

				let amount0	= 0;
				let amount10= 0;
				const taxsService = TaxsService.instance
				const taxRate = taxsService.findByActiveTax(dto.invoiceOn);

				dto.details.forEach( x=>{
					if (x.priceInfo.taxRate==0) {
						amount0 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					} else {
						amount10 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					}
				} );
/*
				const tax = Math.floor(amount10 * (taxRate / 100))
				const totalAmount = amount0 + amount10 + tax
*/
				/*const amount0 = dto.details
            .map(x => x.priceInfo.taxRate==0 ? x.priceInfo.unitPrice * x.priceInfo.quantity : 0)
            .reduce((p, x) => p + x, 0)
				*/

        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: `請求書 ${dto.invoiceNo}`,
                author: this.NEW_COMPANY_NAME,
            },
            content: [
                /* 角印 */
                dto.imprint ? this.getNewCompanyStamp((dto.agencyInfo.agencyName !== "" || dto.invoiceToInfo.invoiceToName !== "") ? 17 : 0) : {},
                /* タイトル */
                this.getTitle("請　求　書"),
                /* 請求日付、番号 */
                this.getDocuementDateAndNumberBill("請求書発行日", dto.printInvoiceOn ? dto.invoiceOn : "", "請求番号", dto.invoiceNo + (dto.invoiceBrNo > 0 ? "-" + String(dto.invoiceBrNo): "") ),
                /* 宛先（顧客） */
                this.getTo(dto.customerInfo, dto.agencyInfo, dto.invoiceToInfo),
                /* スペース */
                this.getSpacer(),
                /* 件名 */
                this.getSubject(dto.subject),
                /* 自社 */
                this.getFrom(!dto.imprint),
                /* スペース */
                this.getSpacer(),
                /* 作成・承認印 */
                this.getStamps(dto.authorUser.userName, dto.authorizerUser.userName),
                /* メッセージ */
                this.getLineMessage("下記の通りご請求申し上げます。"),
                {
                    /* 明細 */
                    table: {
                        widths: [60, "*", 80, 40, 40, 40, 60],
                        headerRows: 1,
                        body: detail,
                    },
                    layout: {
                        // eslint-disable-next-line
                        fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                            return (rowIndex % 2 === 0) ? "#DDFFC9" : null;
                        }
                    }
                },
                /* スペース */
                this.getSpacer(),
                /* 集計 */
                /*this.getPayeeAndPriceOnly(dto.amountText, dto.taxText, dto.totalAmountText, dto.requestType === 1 ? dto.importInfo : undefined),*/
                this.getPayeeAndPriceOnly(amount0.toLocaleString(),amount10.toLocaleString(), dto.taxText, dto.totalAmountText, dto.requestType === 1 ? dto.importInfo : undefined,taxRate.toLocaleString()),
                /* 支払期限 */
                this.getMaturity(dto.maturity),
                /* スペース */
                this.getSpacer(),
                /* 備考 */
                this.getLineMessage("備考", "text-small-left"),
                this.getNote(dto.note),
            ],
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        if (dto.invoiceBrNo > 0) {
          return new FileData({filename: `請求書_${dto.invoiceNo}_${dto.invoiceBrNo}.pdf`, content: content}) 
        } else {
          return new FileData({filename: `請求書_${dto.invoiceNo}.pdf`, content: content}) 
        }
    }

    /**
     * 代理店請求書の作成
     */
    public async generateAgencyInvoice(dto: AgencyInvoice): Promise<FileData> {
        this.init()
        this.COMPANY_FLG = 1 /*NEW*/

				const taxsService = TaxsService.instance
				let taxRate = Math.max.apply(null,dto.details.map(function(x){return x.priceInfo.taxRate;}))
				if (taxRate==0) {
					taxRate = taxsService.findByActiveTax(dto.agencyInvoiceOn);
				}


        const customers = dto.invoices.map(x => x.customerInfo)
                                .sort((a, b) => `${a.customerPrefectureCode}:${a.customerCode}:${a.customerBranchNumber}` > `${b.customerPrefectureCode}:${b.customerCode}:${b.customerBranchNumber}` ? 1 : -1)
                                .reduce((a, v) => {
                                    if (a.findIndex(x => `${v.customerPrefectureCode}:${v.customerCode}:${v.customerBranchNumber}` === `${x.customerPrefectureCode}:${x.customerCode}:${x.customerBranchNumber}`) === -1) {
                                        a.push(v)
                                    }
                                    return a
                                }, [] as CustomerInfo[])
        const title = this.dateUtils.format(dto.agencyInvoiceOn, "yyyy年MM月分")
        const contents = []
        contents.push(this.generateAgencyInvoiceSummary(dto, customers,taxRate))
        customers.forEach(x => {
            contents.push(this.generateAgencyInvoiceCompany(dto, x.customerPrefectureCode, x.customerCode, x.customerBranchNumber, x.customerName,taxRate))
        })
        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: `${title} 請求書 ${dto.agencyInvoiceNo}`,
                author: this.NEW_COMPANY_NAME,
            },
            content: contents.flat(),
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        return new FileData({filename: `請求書_${dto.agencyInvoiceNo}.pdf`, content: content}) 
    }

    /**
     * 代理店請求書（サマリ）の作成
     */
    private generateAgencyInvoiceSummary(dto: AgencyInvoice, customers: CustomerInfo[],taxRate: number) {
        const detailHeader = [[
            {
                text: "No.",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "クライアント名",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const detail = detailHeader.concat(
            customers.map((x, index) => {
                const amount = dto.invoices.filter(y => `${x.customerPrefectureCode}:${x.customerCode}:${x.customerBranchNumber}` === `${y.customerInfo.customerPrefectureCode}:${y.customerInfo.customerCode}:${y.customerInfo.customerBranchNumber}`)
                        .reduce((p, x) => p + x.sumInfo.amount, 0)
                return [
                    {
                        text: (index + 1).toString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.customerName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: amount.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                ]
            })
        )

				let amount0		= 0;
				let amount10	= 0;

				dto.details.forEach( x=>{
					if (x.priceInfo.taxRate==0) {
						amount0 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					} else {
						amount10 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					}
				} );
				const tax = Math.floor(amount10 * (taxRate / 100))
				const totalAmount = amount0 + amount10 + tax


        const title = this.dateUtils.format(dto.agencyInvoiceOn, "yyyy年MM月分")
        const content = [
            /* 角印 */
            this.getNewCompanyStamp(-17),
            /* タイトル */
            // eslint-disable-next-line
            this.getTitle(`${title}　請求書`),
            /* 請求日付、番号 */
            this.getDocuementDateAndNumberBill("請求書発行日", dto.agencyInvoiceOn, "請求番号", dto.agencyInvoiceNo),
            /* 宛先（顧客） */
            this.getCustomer(dto.agencyInfo.customerName),
            /* スペース */
            this.getSpacer(),
            /* 自社 */
            this.getFrom(),
            /* スペース */
            this.getSpacer(),
            /* 作成・承認印 */
            this.getStamps(dto.authorUser.userName, dto.authorizerUser.userName),
            /* メッセージ */
            this.getLineMessage("下記の通りご請求申し上げます。"),
            {
                /* 明細 */
                table: {
                    widths: [25, "*", 80],
                    headerRows: 1,
                    body: detail,
                },
                layout: {
                    // eslint-disable-next-line
                    fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                        return (rowIndex % 2 === 0) ? "#EAF7BE" : null;
                    }
                }
            },
            /* スペース */
            this.getSpacer(),
            /* 集計 */
            /*this.getPayeeAndPriceOnly(dto.amountText, dto.taxText, dto.totalAmountText, undefined),*/
            this.getPayeeAndPriceOnly(amount0.toLocaleString(),amount10.toLocaleString(), tax.toLocaleString(), totalAmount.toLocaleString(), undefined,taxRate.toLocaleString()),
            /* 支払期限 */
            this.getMaturity(),
        ]
        return content
    }

    /**
     * 代理店請求書（会社別）の作成
     */
    private generateAgencyInvoiceCompany(dto: AgencyInvoice, customerPrefectureCode: string, customerCode: string, customerBranchNumber: string, customerName: string,taxRate: number) {
        const detailHeader = [[
            {
                text: "受付番号",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "試験品名称",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査項目",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "単価",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査数",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "報告日",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const invoiceNos = dto.invoices.filter(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}` === `${customerPrefectureCode}:${customerCode}:${customerBranchNumber}`)
                                        .map(x => x.invoiceNo)
        // eslint-disable-next-line
        const details = dto.details.filter(x => invoiceNos.includes((x as any).pk.invoiceNo))
/*
        const amount = details.map(x => x.priceInfo.unitPrice * x.priceInfo.quantity)
                        .reduce((p, x) => p + x, 0)



        const tax = details.map(x => Math.floor(x.priceInfo.unitPrice * x.priceInfo.quantity * (x.priceInfo.taxRate / 100)))
                        .reduce((p, x) => p + x, 0)
*/
        const detail = detailHeader.concat(
            details.map((x, index) => {
                const same = index !== 0 && details[index - 1].requestNo === x.requestNo
                const border = same ? [true, false, true, true] : [true, true, true, true]

                return [
                    {
                        text: same ? "" : x.requestNo,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: same ? "" : x.specimenName,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: x.inspectionInfo.inspectionShortName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.unitPrice.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.quantity.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: (x.priceInfo.unitPrice * x.priceInfo.quantity).toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: this.dateUtils.toJapanFormat(x.reportOn),
                        style: "text-xsmall-center",
                        border: [true, true, true, true],
                    }
                ]
            })
        )


				let amount0= 0;
				let amount10= 0;

				details.forEach( x=>{
					if (x.priceInfo.taxRate==0) {
						amount0 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					} else {
						amount10 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					}
				} );
				const tax = Math.floor(amount10 * (taxRate / 100))
				const totalAmount = amount0 + amount10 + tax


        const title = this.dateUtils.format(dto.agencyInvoiceOn, "yyyy年MM月分")
        const content = [
            /* 改ページ */
            this.getPageBrake(),
            /* タイトル */
            // eslint-disable-next-line
            this.getTitle(`${title}　請求書`),
            /* 請求日付、番号 */
            this.getDocuementDateAndNumberBill("請求書発行日", dto.agencyInvoiceOn, "請求番号", dto.agencyInvoiceNo),
            /* 宛先（顧客） */
            this.getAgency(customerName, dto.agencyInfo.customerName),
            /* スペース */
            this.getSpacer(),
            {
                /* 明細 */
                table: {
                    widths: [60, "*", 80, 40, 40, 40, 60],
                    headerRows: 1,
                    body: detail,
                },
                layout: {
                    // eslint-disable-next-line
                    fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                        return (rowIndex % 2 === 0) ? "#EAF7BE" : null;
                    }
                }
            },
            /* スペース */
            this.getSpacer(),
            /* 集計 */
            this.getPriceOnlyBill(amount0.toLocaleString(),amount10.toLocaleString(), tax.toLocaleString(), totalAmount.toLocaleString(), "請求金額",taxRate.toLocaleString()),
        ]
        return content
    }

    /**
     * 合算請求書の作成
     */
    public async generateTotalInvoice(dto: TotalInvoice): Promise<FileData> {
        this.init()
        this.COMPANY_FLG = 1 /*NEW*/
        const detailHeader = [[
            {
                text: "受付番号",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "試験品名称",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査項目",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "単価",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "検査数",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "金額",
                style: "text-center",
                border: [true, true, true, true],
            },
            {
                text: "報告日",
                style: "text-center",
                border: [true, true, true, true],
            }
        ]]
        const detail = detailHeader.concat(
            dto.details.map((x, index) => {
                const same = index !== 0 && dto.details[index - 1].requestNo === x.requestNo
                const border = same ? [true, false, true, true] : [true, true, true, true]

                return [
                    {
                        text: same ? "" : x.requestNo,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: same ? "" : x.specimenName,
                        style: "text-xsmall-left",
                        border: border,
                    },
                    {
                        text: x.inspectionInfo.inspectionShortName,
                        style: "text-xsmall-left",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.unitPrice.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: x.priceInfo.quantity.toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: (x.priceInfo.unitPrice * x.priceInfo.quantity).toLocaleString(),
                        style: "text-xsmall-right",
                        border: [true, true, true, true],
                    },
                    {
                        text: this.dateUtils.toJapanFormat(x.reportOn),
                        style: "text-xsmall-center",
                        border: [true, true, true, true],
                    }
                ]
            })
        )

				let amount0= 0;
				let amount10= 0;
				const taxsService = TaxsService.instance
				//0%しかなかった場合の為
				let taxRate = taxsService.findByActiveTax(dto.totalInvoiceOn);

				dto.details.forEach( x=>{
					if (x.priceInfo.taxRate==0) {
						amount0 += x.priceInfo.unitPrice * x.priceInfo.quantity;
					} else {
						amount10 += x.priceInfo.unitPrice * x.priceInfo.quantity;
						taxRate = x.priceInfo.taxRate
					}
				} );
				const tax = Math.floor(amount10 * (taxRate / 100))
				const totalAmount = amount0 + amount10 + tax

        const title = this.dateUtils.format(dto.totalInvoiceOn, "yyyy年MM月分")
        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            info: {
                title: `${title} 合算請求書 ${dto.totalInvoiceNo}`,
                author: this.NEW_COMPANY_NAME,
            },
            content: [
                /* 角印 */
                dto.imprint ? this.getNewCompanyStamp(-17) : {},
                /* タイトル */
                // eslint-disable-next-line
                this.getTitle(`${title}　合算請求書`),
                /* 請求日付、番号 */
                this.getDocuementDateAndNumberBill("請求書発行日", dto.printInvoiceOn ? dto.totalInvoiceOn : "", "請求番号", dto.totalInvoiceNo),
                /* 宛先（顧客） */
                this.getCustomer(dto.customerInfo.customerName),
                /* スペース */
                this.getSpacer(),
                /* 自社 */
                this.getFrom(!dto.imprint),
                /* スペース */
                this.getSpacer(),
                /* 作成・承認印 */
                this.getStamps(dto.authorUser.userName, dto.authorizerUser.userName),
                /* メッセージ */
                this.getLineMessage("下記の通りご請求申し上げます。"),
                {
                    /* 明細 */
                    table: {
                        widths: [60, "*", 80, 40, 40, 40, 60],
                        headerRows: 1,
                        body: detail,
                    },
                    layout: {
                        // eslint-disable-next-line
                        fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                            return (rowIndex % 2 === 0) ? "#BEF7C2" : null;
                        }
                    }
                },
                /* スペース */
                this.getSpacer(),
                /* 集計 */
                /*this.getPayeeAndPriceOnly(dto.amountText, dto.taxText, dto.totalAmountText, undefined),*/
                this.getPayeeAndPriceOnly(amount0.toLocaleString(),amount10.toLocaleString(), tax.toLocaleString(), totalAmount.toLocaleString(), undefined,taxRate.toLocaleString()),

                /* 支払期限 */
                this.getMaturity(),
                /* スペース */
                this.getSpacer(),
                /* 備考 */
                this.getLineMessage("備考", "text-small-left"),
                this.getNote(dto.note),
            ],
            styles: this.getStyle(),
            defaultStyle: this.getDefaultStyle(),
        }
        const content = await pdfMake.createPdf(docDefinition).getDataUrl() as string
        return new FileData({filename: `合算請求書_${dto.totalInvoiceNo}.pdf`, content: content}) 
    }

    /**
     * pdfmakeの初期設定
     */
    private init() {
        pdfMake.fonts = {
            "IPA_gothic": {
                normal: "ipaexg.ttf",
                bold: "ipaexg.ttf",
                italics: "ipaexg.ttf",
                bolditalics: "ipaexg.ttf",
            },
            "IPA_mincho": {
                normal: "ipaexm.ttf",
                bold: "ipaexm.ttf",
                italics: "ipaexm.ttf",
                bolditalics: "ipaexm.ttf",
            }
        }
    }

    /**
     * ドキュメントのタイトルの取得
     */
    private getTitle(documentName: string) {
        /* タイトル */
        return {
            table: {
                widths: ["100%"],
                body:[[
                    {
                        text: documentName,
                        style: "header",
                        font: "IPA_gothic",
                        border: [false, false, false, false],
                    },
                ]]
            }
        }
    }

    /**
     * ドキュメントの日付、番号情報
     * @param dateName
     * @param date 
     * @param noName 
     * @param no 
     */
    private getDocuementDateAndNumber(dateName: string, date: string, noName: string, no: string) {
        return {
            table: {
                widths: ["*", 50, 80],
                body: [
                    [
                        {
                            text: "",
                            style: "spacer",
                            border: [false, false, false, false],
                        },{
                            text: dateName,
                            style: "text-small-right",
                            border: [false, false, false, false],
                        },{
                            text: this.dateUtils.toJapanFormat(date),
                            style: "text-small-left",
                            border: [false, false, false, false],
                        }
                    ],[
                        {
                            text: "",
                            style: "spacer",
                            border: [false, false, false, false],
                        },{
                            text: noName,
                            style: "text-small-right",
                            border: [false, false, false, false],
                        },{
                            text: no,
                            style: "text-small-left",
                            border: [false, false, false, false],
                        },
                    ]
                ]
            }
        }
    }

    /**
     * ドキュメントの日付、番号情報 請求書用
     * @param dateName
     * @param date 
     * @param noName 
     * @param no 
     */
    private getDocuementDateAndNumberBill(dateName: string, date: string, noName: string, no: string) {
        return {
            table: {
                widths: ["*", 60, 95],
                body: [
                    [
                        {
                            text: "",
                            style: "spacer",
                            border: [false, false, false, false],
                        },{
                            text: dateName,
                            style: "text-small-right",
                            border: [false, false, false, false],
                        },{
                            text: this.dateUtils.toJapanFormat(date),
                            style: "text-small-left",
                            border: [false, false, false, false],
                        }
                    ],[
                        {
                            text: "",
                            style: "spacer",
                            border: [false, false, false, false],
                        },{
                            text: "登録番号",
                            style: "text-small-right",
                            border: [false, false, false, false],
                        },{
                            text: "T7280001003728",
                            style: "text-small-left",
                            border: [false, false, false, false],
                        },
                    ],[
                        {
                            text: "",
                            style: "spacer",
                            border: [false, false, false, false],
                        },{
                            text: noName,
                            style: "text-small-right",
                            border: [false, false, false, false],
                        },{
                            text: no,
                            style: "text-small-left",
                            border: [false, false, false, false],
                        },
                    ]
                ]
            }
        }
    }


    /**
     * 件名の取得
     * @param subject
     */
    private getSubject(subject: string) {
        return {
            table: {
                widths: [260, "*"],
                body:[[
                    {
                        text: subject,
                        style: "subject",
                        border: [false, false, false, true],
                    },
                    {
                        text: "の件",
                        style: "subject",
                        border: [false, false, false, false],
                    },
                ]]
            }
        }
    }

    /**
     * 宛先（顧客）の取得
     * @param customerInfo
     * @param agencyInfo
     * @param customerInfo
     */
    private getTo(customerInfo: CustomerInfo, agencyInfo: AgencyInfo, invoiceToInfo: InvoiceToInfo | null) {
        if (invoiceToInfo !== null && invoiceToInfo.invoiceToName !== "") {
            /* 請求先宛て */
            return this.getInvoice(customerInfo.customerName, invoiceToInfo.invoiceToName, invoiceToInfo.invoiceToNameHonorific)
        } else if (agencyInfo.agencyName !== "") {
            /* 代理店宛て */
            return this.getAgency(customerInfo.customerName, agencyInfo.agencyName)
        } else {
            /* 顧客宛て */
            return this.getCustomer(customerInfo.customerName)
        }
    }

    /**
     * 顧客宛て（宛先）の取得
     * @param customerName
     */
    private getCustomer(customerName: string) {
        return {
            table: {
                widths: [260, "*"],
                body:[[
                    {
                        text: customerName,
                        style: customerName.length < 22 ? "customer" : "customer-small",
                        border: [false, false, false, true],
                    },
                    {
                        text: "御中",
                        style: "customer",
                        border: [false, false, false, false],
                    },
                ]]
            }
        }
    }

    /**
     * 代理店宛て（宛先）の取得
     * @param customerName
     * @paran agencyName
     */
    private getAgency(customerName: string, agencyName: string) {
        return {
            table: {
                widths: [260, "*"],
                body:[[
                    {
                        text: agencyName,
                        style: agencyName.length < 22 ? "customer" : "customer-small",
                        border: [false, false, false, true],
                    },
                    {
                        text: "御中",
                        style: "customer",
                        border: [false, false, false, false],
                    },
                ],[
                    {
                        // eslint-disable-next-line
                        text: `(${customerName}　様)`,
                        style: customerName.length < 18 ? "customer" : "customer-small",
                        border: [false, false, false, false],
                    },
                    {
                        text: "",
                        style: "customer",
                        border: [false, false, false, false],
                    },
                ]]
            }
        }
    }

    /**
     * 請求先宛て（宛先）の取得
     * @param customerName
     * @paran agencyName
     * @paran nameHonorific
    */
    private getInvoice(customerName: string, agencyName: string,nameHonorific: string) {
        return {
            table: {
                widths: [260, "*"],
                body:[[
                    {
                        text: agencyName,
                        style: agencyName.length < 22 ? "customer" : "customer-small",
                        border: [false, false, false, true],
                    },
                    {
                        text: `${nameHonorific}`,
                        style: "customer",
                        border: [false, false, false, false],
                    },
                ],[
                    {
                        // eslint-disable-next-line
                        text: `(${customerName}　様)`,
                        style: customerName.length < 18 ? "customer" : "customer-small",
                        border: [false, false, false, false],
                    },
                    {
                        text: "",
                        style: "customer",
                        border: [false, false, false, false],
                    },
                ]]
            }
        }
    }

    /**
     * 自社（差出人）の取得
     * @param isCEO     true: 代表者名あり false: 代表者名なし
     */
    private getFrom(isCEO = false) {
        return {
            table: {
                widths: ["*", this.COMPANY_FLG === 1 ? 215 : 210],
                body: [[
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    isCEO ? this.getFromCompanyCEO() : this.getFromCompany(),
                ]]
            },
        }
    }

    /**
     * 見積条件、自社（差出人）の取得
     * @param expirationDate
     * @param tradingCondition
     * @param requiredAmount
     * @param isCEO
     */
    private getConditionAndFrom(expirationDate: string, tradingCondition: string, requiredAmount: string, isCEO: boolean) {
        return {
            table: {
                widths: [250, "*", 215],
                body: [[
                    {
                        table: {
                            widths: [50, 200],
                            body: [
                                [
                                    {
                                        text: "有効期限",
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },{
                                        text: expirationDate,
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },
                                ],[
                                    {
                                        text: "取引条件",
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },{
                                        text: tradingCondition,
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },
                                ],[
                                    {
                                        text: "必要量",
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },{
                                        text: requiredAmount,
                                        style: "text-small-left",
                                        border: [false, false, false, true],
                                    },
                                ]
                            ]
                        },
                        margin: [-5, -3],
                        border: [false, false, false, false],
                    },
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    isCEO ? this.getFromCompanyCEO() : this.getFromCompany(),
                ]]
            },
        }
    }

    /**
     * 自社（差出人）情報の取得
     */
    private getFromCompany() {
        return {
            text: [
                { text: `${this.COMPANY_FLG == 1 ? this.NEW_COMPANY_NAME : this.COMPANY_NAME}\n` },
                { text: `${this.COMPANY_ADDRESS}\n` },
                { text: `TEL：${this.COMPANY_TEL}\n` },
                { text: `FAX：${this.COMPANY_FAX}` },
            ],
            style: "from",
            border: [false, false, false, false],
        }
    }

    /**
     * 自社（差出代表者）情報の取得
     */
    private getFromCompanyCEO() {
        return {
            text: [
                { text: `${this.COMPANY_ADDRESS}\n` },
                { text: `${this.COMPANY_FLG == 1 ? this.NEW_COMPANY_NAME : this.COMPANY_NAME}\n` },
                { text: `${this.COMPANY_FLG == 1 ? this.NEW_COMPANY_CEO_NAME : this.COMPANY_CEO_NAME}\n` },
                { text: `TEL：${this.COMPANY_TEL}\n` },
                { text: `FAX：${this.COMPANY_FAX}` },
            ],
            style: "from",
            border: [false, false, false, false],
        }
    }

    /**
     * 作成・承認印
     * @param authorUserName
     * @param authorizerUserName 
     */
    private getStamps(authorUserName: string, authorizerUserName: string) {
        return {
            table: {
                widths: ["*", 30, 30],
                heights: 30,
                body:[[
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    {
                        svg: this.getStamp(authorizerUserName),
                        width: 28,
                        height: 28,
                        style: "text-center",
                        border: [true, true, true, true],
                    },
                    {
                        svg: this.getStamp(authorUserName),
                        width: 28,
                        height: 28,
                        style: "text-center",
                        border: [true, true, true, true],
                    },
                ]]
            }
        }
    }

    /**
     * １行メッセージの取得
     * @param message 
     */
    private getLineMessage(message: string, style = "text-left", border = [false, false, false, false]) {
        return {
            table: {
                widths: ["*"],
                body:[[
                    {
                        text: message,
                        style: style,
                        border: border,
                    },
                ]]
            }
        }
    }

    /**
     * 集計金額情報
     * @param amount
     * @param tax 
     * @param totalAmount 
     * @param totalTaitle
     */
    private getPrice(amount: string, tax: string, totalAmount: string, totalTitle: string) {
        return {
            table: {
                widths: [60, 80],
                body: [
                    [
                        {
                            text: "合計金額",
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${amount}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ],[
                        {
                            text: "消費税",
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${tax}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ],[
                        {
                            text: totalTitle,
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${totalAmount}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ]
                ]
            },
            margin: [-5, -3],
            border: [false, false, false, false],
        }
    }


    /**
     * 集計金額情報 税別毎
     * @param amount
     * @param tax 
     * @param totalAmount 
     * @param totalTaitle
     */
    private getPriceBill(amount0: string, amount10: string, tax: string, totalAmount: string, totalTitle: string,taxRate: string) {
        return {
            table: {
                widths: [70, 80],
                body: [
                    [
                        {
                            text: "0%対象",
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${amount0}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ],[
                        {
                            text:`${taxRate}%対象`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${amount10}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ],[
                        {
                            text: `${taxRate}%消費税`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${tax}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ],[
                        {
                            text: totalTitle,
                            style: "text-right",
                            border: [true, true, true, true],
                        },{
                            text: `¥${totalAmount}`,
                            style: "text-right",
                            border: [true, true, true, true],
                        },
                    ]
                ]
            },
            margin: [-5, -3],
            border: [false, false, false, false],
        }
    }



    /**
     * 集計金額情報のみ
     * @param amount
     * @param tax 
     * @param totalAmount 
     * @param totalTitle 
     */
    private getPriceOnly(amount: string, tax: string, totalAmount: string, totalTitle: string) {
        return {
            table: {
                widths: ["*", 149],
                body: [[
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    this.getPrice(amount, tax, totalAmount, totalTitle)
                ]]
            },
        }
    }

    /**
     * 集計金額情報のみ(請求用 税別)
     * @param amount
     * @param tax 
     * @param totalAmount 
     * @param totalTitle 
     */
    private getPriceOnlyBill(amount0: string,amount10: string, tax: string, totalAmount: string, totalTitle: string, taxRate: string) {
        return {
            table: {
                widths: ["*", 149],
                body: [[
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    /*this.getPrice(amount, tax, totalAmount, totalTitle)*/
                    this.getPriceBill(amount0,amount10,tax, totalAmount, totalTitle, taxRate)
                ]]
            },
        }
    }

    /**
     * 納品予定日＆集計 情報
     * @param deliveryOn
     * @param amount
     * @param tax 
     * @param totalAmount 
     */
    private getDeriveryOnAndPrice(deliveryOn: string, amount: string, tax: string, totalAmount: string) {
        return {
            table: {
                widths: [149, "*", 149],
                body: [[
                    {
                        table: {
                            widths: [60, 80],
                            body: [
                                [
                                    {
                                        text: "納品予定日",
                                        style: "text-right",
                                        border: [true, true, true, true],
                                    },{
                                        text: this.dateUtils.toJapanFormat(deliveryOn),
                                        style: "text-left",
                                        border: [true, true, true, true],
                                    },
                                ],
                            ]
                        },
                        margin: [-5, -3],
                        border: [false, false, false, false],
                    },{
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    this.getPrice(amount, tax, totalAmount, "発注金額")
                ]]
            },
            margin: 0,
        }
    }

    /**
     * 振込先＆集計金額情報
     * @param amount
     * @param tax 
     * @param totalAmount 
     * @param ImportInfo
     */
    /*private getPayeeAndPriceOnly(amount: string, tax: string, totalAmount: string, importInfo: ImportInfo | undefined) {*/
    private getPayeeAndPriceOnly(amount0: string, amount10: string, tax: string, totalAmount: string, importInfo: ImportInfo | undefined,taxRate: string) {
        return {
            table: {
                widths: [289, "*", 149],
                body: [[
                    importInfo === undefined ? this.getNoneImportInfo() : this.getImportInfo(importInfo),
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    this.getPriceBill(amount0, amount10, tax, totalAmount, "請求金額",taxRate)
                ],[
                    "",
                    {
                        text: "",
                        style: "spacer",
                        border: [false, false, false, false],
                    },
                    this.getPayee(),
                ]],
            },
            border: [false, false, false, false],
        }
    }

    /**
     * 輸入情報なし
     */
    private getNoneImportInfo() {
        return {
            rowSpan: 2,
            text: "",
            style: "spacer",
            border: [false, false, false, false],
        }
    }

    /**
     * 輸入情報
     * @param ImportInfo
     */
    private getImportInfo(importInfo: ImportInfo) {
        return {
            rowSpan: 2,
            text: [
                {
                    text: `蔵地場所: ${importInfo.storagePlace}\n`,
                    style: "text-small-left",
                },
                {
                    // eslint-disable-next-line
                    text: `  　抜取日 : ${this.dateUtils.toJapanFormat(importInfo.samplingOn)}\n`,
                    style: "text-small-left",
                },
                {
                    // eslint-disable-next-line
                    text: `  　入船日 : ${this.dateUtils.toJapanFormat(importInfo.arrivalOn)}\n`,
                    style: "text-small-left",
                },
                {
                    // eslint-disable-next-line
                    text: `  　　船名: ${importInfo.shipName}\n`,
                    style: "text-small-left",
                },
                {
                    text: `輸入業者: ${importInfo.importer}\n`,
                    style: "text-small-left",
                },
            ],
            border: [false, false, false, false],
        }
    }

    /**
     * 振込先
     * @param amount
     * @param tax 
     * @param totalAmount 
     */
    private getPayee() {
        return {
            text: [
                {
                    text: "振込先\n  　みずほ銀行　横浜中央支店\n  　普通　1534031\n",
                    style: "text-small-left",
                },{
                    text: "※振込手数料はご負担願います。\n\n",
                    style: "text-xsmall-left",
                },
            ],
            border: [false, false, false, false],
        }
    }

    /**
     * 支払期限
     * @param message 
     */
    private getMaturity(message = "請求書発行日翌月末迄に銀行振込でお願い致します。") {
        return {
                text: message,
                style: "text-xsmall-right",
                margin: [0, 0, 0, 0]
        }
    }

    /**
     * 備考の取得
     * @param note
     */
    private getNote(note: string) {
        return {
            table: {
                widths: ["100%"],
                heights: 40,
                body:[[
                    {
                        text: note,
                        style: "text-left",
                        border: [true, true, true, true],
                    },
                ]]
            },
        }
    }

    /**
     * １行スペース調整
     */
    private getSpacer() {
        return {
            text: "",
            margin: [0, 5, 0, 0],
            border: [false, false, false, false],
        }
    }

    /**
     * 改ページ
     * @param pageBreak  before / after
     */
    private getPageBrake(pageBreak = "before") {
        return {
            text: "",
            pageBreak: pageBreak,
        }
    }

    /**
     * スタイル定義を取得
     */
    private getStyle() {
        return {
            "header": {
                fontSize: 24,
                alignment: "center",
            },
            "customer": {
                fontSize: 12,
                alignment: "left",
            },
            "customer-small": {
                fontSize: 10,
                alignment: "left",
            },
            "subject": {
                fontSize: 12,
                alignment: "left",
            },
            "from": {
                fontSize: 10,
            },
            "spacer": {
            },
            "text-xsmall-right": {
                fontSize: 8,
                alignment: "right",
            },
            "text-xsmall-left": {
                fontSize: 8,
                alignment: "left",
            },
            "text-xsmall-center": {
                fontSize: 8,
                alignment: "center",
            },
            "text-small-right": {
                fontSize: 10,
                alignment: "right",
            },
            "text-small-left": {
                fontSize: 10,
                alignment: "left",
            },
            "text-small-center": {
                fontSize: 10,
                alignment: "center",
            },
            "text-right": {
                alignment: "right",
            },
            "text-left": {
                alignment: "left",
            },
            "text-center": {
                alignment: "center",
            },
        }
    }

    /**
     * デフォルトスタイルを取得
     */
    private getDefaultStyle() {
        return {
            font: this.DEFAULT_STYLE,
            fontSize: 12,
            border: [false, false, false, false],
        }
    }

    /**
     * 印影のSVG取得
     * @param userName 
     */
    private getStamp(userName: string) {
        const pos = userName.indexOf(" ")
        const name = pos === -1 ? userName.substring(0, 6) : userName.substring(0, pos)
        const index = name.length
        const style = [
            {
                fontSize: 15,
                x: 7,
                y: 19,
                dx: "",
                dy: "",
            },
            {
                fontSize: 15,
                x: 7,
                y: 19,
                dx: "",
                dy: "",
            },
            {
                fontSize: 10,
                x: 9,
                y: 13,
                dx: "0, -10",
                dy: "0, 10",
            },
            {
                fontSize: 8,
                x: 10,
                y: 10,
                dx: "0, -8, -8",
                dy: "0, 7, 7",
            },
            {
                fontSize: 8,
                x: 14,
                y: 13,
                dx: "0, -8, -16, -8",
                dy: "0, 8, -8, 8",
            },
            {
                fontSize: 7,
                x: 14,
                y: 10,
                dx: "0, -7, -7, -14, -7",
                dy: "0, 7, 7, -11, 7",
            },
            {
                fontSize: 7,
                x: 14,
                y: 10,
                dx: "0, -7, -7, -14, -7, -7",
                dy: "0, 7, 7, -14, 7, 7",
            },
        ][index]
        return `<svg width="28" height="28" viewBox="0 0 28 28">
                        <circle cx="14" cy="14" r="12" style="fill:white; stroke:#E77416; stroke-width:1"/>
                        <g font-family="IPA_mincho" font-size="${style.fontSize}">
                          <text x="${style.x}" y="${style.y}" dx="${style.dx}" dy="${style.dy}" fill="#E77416" writing-mode="tb">${name}</text>
                        </g>
                      </svg>`
    }

    /**
     * 角印を取得する
     */
    private getCompanyStamp(offset = 0) {
        return {
            image: this.COMPANY_STAMP_IMAGE,
            width: 64,
            height: 64,
            absolutePosition: {x: 450, y: 126 + offset}
        }
    }
    
    private getNewCompanyStamp(offset = 0) {
        return {
            image: this.NEW_COMPANY_STAMP_IMAGE,
            width: 64,
            height: 65,
            absolutePosition: {x: 450, y: 126 + offset}
        }
    }
}
